var xxx, ccc;
window.theme = window.theme || {};
window.home_video_list = window.home_video_list || {};
/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $("a[href*=#]").on(
      "click",
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).off("focusin");

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current ts
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image || variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position
    };

    this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer")
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on("click", $.proxy(this.open, this));
    this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen && typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function() {
      return false;
    });

    this.nodes.$page.on(
      "click.drawer",
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    header: ".site-header",
    navigation: "ul#menu-primary-header"
  };

  function beforeInit() {}
  function initMenu() {
    $(".sub-active")
      .closest(".parent-menu-item")
      .addClass("current-menu-ancestor");
  }
  function headerSticky() {
    if (!$(document.body).hasClass("sticky-header")) {
      return;
    }
    $(window).on("scroll", function() {
      var scrollTop = 5;
		
      if($(document.body).hasClass('header-slider-top')) {
      	scrollTop = $("#header-slider").height() + $("#un-header-minimized").height();
      }
      if ($(window).scrollTop() > scrollTop) {
        $(selectors.header).addClass("minimized");
        $(document.body).addClass("sticky-header-show") ;
      } else {
        $(selectors.header).removeClass("minimized");
        $(document.body).removeClass("sticky-header-show") ;
      }
    });

    $(window)
      .on("resize", function() {
        if ($(window).width() < 768) {
          var wHeight = $(selectors.header).height();
          $("#un-header-minimized").height(wHeight);
        } else {
          $("#un-header-minimized").removeAttr("style");
        }
      })
      .trigger("resize");
  }

  function init() {
    if (!$(selectors.header).length) {
      return;
    }

    beforeInit();
    initMenu();
    headerSticky();
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: "#search-modal"
  };

  function beforeInit() {}

  function instanceSearch() {
    var xhr = null,
      searchCache = {},
      $modal = $("#search-modal"),
      $form = $modal.find("form"),
      $search = $form.find("input.search-field"),
      $results = $modal.find(".search-results");

    $modal
      .on("keyup", ".search-field", function(e) {
        var valid = false;

        if (typeof e.which == "undefined") {
          valid = true;
        } else if (typeof e.which == "number" && e.which > 0) {
          valid = !e.ctrlKey && !e.metaKey && !e.altKey;
        }

        if (!valid) {
          return;
        }

        if (xhr) {
          xhr.abort();
        }

        search();
      })
      .on("change", ".product-cats input", function() {
        if (xhr) {
          xhr.abort();
        }

        search();
      })
      .on("focusout", ".search-field", function() {
        if ($search.val().length < 2) {
          $results.find(".rt-unero, .buttons").slideUp(function() {
            $modal.removeClass(
              "searching searched actived found-products found-no-product invalid-length"
            );
          });
        }
      });

    outSearch();

    /**
		 * Private function for search
		 */
    function search() {
      var keyword = $search.val(), cat = "";

      if ($modal.find(".product-cats").length > 0) {
        cat = $modal.find(".product-cats input:checked").val();
      }

      if (keyword.length < 2) {
        $modal
          .removeClass("searching found-products found-no-product")
          .addClass("invalid-length");
        return;
      }

      $modal
        .removeClass("found-products found-no-product")
        .addClass("searching");

      var keycat = keyword + cat;

      if (keycat in searchCache) {
        var result = searchCache[keycat];

        $modal.removeClass("searching");

        $modal.addClass("found-products");

        $results.find(".rt-unero").html(result.products);

        $(document.body).trigger("unero_ajax_search_request_success", [
          $results
        ]);

        $results.find(".rt-unero, .buttons").slideDown(function() {
          $modal.removeClass("invalid-length");
        });

        $modal.addClass("searched actived");
      } else {
        var url = "/search?view=ajax&" + $form.serialize();
        xhr = $.get(url, function(response) {
          ccc = response;
          var $products = $(response).html();
          $modal.removeClass("searching");
          $modal.addClass("found-products");

          $results.find(".rt-unero").html($products);

          $results.find(".rt-unero, .buttons").slideDown(function() {
            $modal.removeClass("invalid-length");
          });

          $(document.body).trigger("unero_ajax_search_request_success", [
            $results
          ]);

          // Cache
          searchCache[keycat] = {
            found: true,
            products: $products
          };

          $modal.addClass("searched actived");
        });
      }

      $(document.body).on("unero_ajax_search_request_success", function(
        e,
        $results
      ) {
        $results.find("img.lazy").lazyload({
          threshold: 1000
        });
      });
    }

    /**
		 * Private function for click out search
		 */
    function outSearch() {
      var $modal = $(".header-layout-4").find("#search-modal"),
        $search = $modal.find("input.search-field");
      if ($modal.length <= 0) {
        return;
      }

      $(window).on("scroll", function() {
        if ($(window).scrollTop() > 10) {
          $modal.removeClass("show found-products searched");
        }
      });

      $(document).on("click", function(e) {
        var target = e.target;
        if (
          !$(target).closest(".extra-menu-item").hasClass("menu-item-search")
        ) {
          $modal.removeClass(
            "searching searched found-products found-no-product invalid-length"
          );
        }
      });

      $modal.on("click", ".t-icon", function(e) {
        if ($modal.hasClass("actived")) {
          e.preventDefault();
          $search.val("");
          $modal.removeClass(
            "searching searched actived found-products found-no-product invalid-length"
          );
        }
      });
    }
  }

  function init() {
    if (!$(selectors.search).length) {
      return;
    }

    beforeInit();
    instanceSearch();
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.CurrencyPicker = (function() {
  var selectors = {
    currency: ".currency_switcher",
    currencyPicker: ".currency_switcher .currency",
    currencyActive: ".currency_switcher .currency.active"
  };

  var settings = {
    currency_format: "",
    shop_currency: "",
    default_currency: "",
    money_with_currency_format: "",
    money_format: ""
  };

  function _currencyJs() {
    var currency_wrap = $(selectors.currency).first().closest(".currency-wrapper");
    settings.currency_format = currency_wrap.find(".currency_format").val();
    settings.shop_currency = currency_wrap.find(".shop_currency").val();
    settings.default_currency = currency_wrap.find(".default_currency").val();
    settings.money_with_currency_format = currency_wrap
      .find(".money_with_currency_format")
      .val();
    settings.money_format = currency_wrap.find(".money_format").val();

    Currency.format = settings.currency_format;
    var shopCurrency = settings.shop_currency;
    Currency.moneyFormats[shopCurrency].money_with_currency_format =
      settings.money_with_currency_format;
    Currency.moneyFormats[shopCurrency].money_format = settings.money_format;
    var defaultCurrency = settings.default_currency;

    try {
      var cookieCurrency = Currency.cookie.read();

      // Fix for customer account pages
      $("span.money span.money").each(function() {
        $(this).parents("span.money").removeClass("money");
      });

      // Saving the current price
      $("span.money").each(function() {
        $(this).attr("data-currency-" + settings.shop_currency, $(this).html());
      });

      // If there's no cookie.
      if (cookieCurrency == null) {
        if (shopCurrency !== defaultCurrency) {
          Currency.convertAll(shopCurrency, defaultCurrency);
        } else {
          Currency.currentCurrency = defaultCurrency;
        }
        Currency.cookie.write(defaultCurrency);
      } else if (
        $(selectors.currency).length &&
        $(
          selectors.currency + " .currency[data-code=" + cookieCurrency + "]"
        ).size() === 0
      ) {
        // If the cookie value does not correspond to any value in the currency dropdown.
        Currency.currentCurrency = shopCurrency;
        Currency.cookie.write(shopCurrency);
      } else if (cookieCurrency === shopCurrency) {
        Currency.currentCurrency = shopCurrency;
      } else {
        Currency.convertAll(shopCurrency, cookieCurrency);
      }

      $(selectors.currency).on("click", ".currency:not(.active)", function() {
        var newCurrency = $(this).attr("data-code");
        Currency.convertAll(Currency.currentCurrency, newCurrency);

        $(selectors.currencyPicker).removeClass("active");
        $(selectors.currencyPicker).closest("li").removeClass("actived");
        $(this).addClass("active");
        $(this).closest("li").addClass("actived");
        $(".menu-item-currency.currency-wrapper")
          .find("span.current")
          .html(
            $(this).html() +
              '<span class="toggle-children i-icon arrow_carrot-down"></span>'
          );
      });

      var original_selectCallback = window.selectCallback;
      var selectCallback = function(variant, selector) {
        original_selectCallback(variant, selector);
        Currency.convertAll(
          shopCurrency,
          $(selectors.currencyActive).attr("data-code")
        );

        $(selectors.currencyPicker).removeClass("active");
        $(selectors.currencyPicker).closest("li").removeClass("actived");
        $(
          selectors.currency +
            " .currency[data-code=" +
            Currency.currentCurrency +
            "]"
        ).addClass("active");
        $(
          selectors.currency +
            " .currency[data-code=" +
            Currency.currentCurrency +
            "]"
        )
          .closest("li")
          .addClass("actived");
        $(".menu-item-currency.currency-wrapper")
          .find("span.current")
          .html(
            Currency.currentCurrency +
              '<span class="toggle-children i-icon arrow_carrot-down"></span>'
          );
      };

      $("body").on("ajaxCart.afterCartLoad", function(cart) {
        Currency.convertAll(
          shopCurrency,
          $(selectors.currencyActive).attr("data-code")
        );

        $(selectors.currencyPicker).removeClass("active");
        $(selectors.currencyPicker).closest("li").removeClass("actived");
        $(
          selectors.currency +
            " .currency[data-code=" +
            Currency.currentCurrency +
            "]"
        ).addClass("active");
        $(
          selectors.currency +
            " .currency[data-code=" +
            Currency.currentCurrency +
            "]"
        )
          .closest("li")
          .addClass("actived");
        $(".menu-item-currency.currency-wrapper")
          .find("span.current")
          .html(
            Currency.currentCurrency +
              '<span class="toggle-children i-icon arrow_carrot-down"></span>'
          );
      });

      $(selectors.currencyPicker).removeClass("active");
      $(selectors.currencyPicker).closest("li").removeClass("actived");
      $(
        selectors.currency +
          " .currency[data-code=" +
          Currency.currentCurrency +
          "]"
      ).addClass("active");
      $(
        selectors.currency +
          " .currency[data-code=" +
          Currency.currentCurrency +
          "]"
      )
        .closest("li")
        .addClass("actived");
      $(".menu-item-currency.currency-wrapper")
        .find("span.current")
        .html(
          Currency.currentCurrency +
            '<span class="toggle-children i-icon arrow_carrot-down"></span>'
        );
    } catch (err) {
      console.log(err.message);
    }
  }

  
  function _currencyLiquid() {
    // change currencies
    $(selectors.currency).off('click', '.currency:not(.active)');
    $(selectors.currency).on('click', '.currency:not(.active)', function() {
      var new_currency = $(this).data('code');
      var location = window.location;
      var new_url = location.pathname + location.search + location.hash;


      var form = document.createElement('form');
      form.setAttribute('action', '/cart/update');
      form.setAttribute('method', 'POST');
      form.setAttribute('style', 'display:none');

      var input_form_type = document.createElement('input');
      input_form_type.setAttribute('type', 'hidden');
      input_form_type.setAttribute('name', 'form_type');
      input_form_type.setAttribute('value', 'currency');

      var input_currency = document.createElement('input');
      input_currency.setAttribute('type', 'hidden');
      input_currency.setAttribute('name', 'currency');
      input_currency.setAttribute('value', new_currency);

      var input_return_to = document.createElement('input');
      input_return_to.setAttribute('type', 'hidden');
      input_return_to.setAttribute('name', 'return_to');
      input_return_to.setAttribute('value', new_url);

      form.appendChild(input_form_type);
      form.appendChild(input_currency);
      form.appendChild(input_return_to);

      $(form).appendTo('body').submit();
    });
  }
  function currencyPicker(target) {
    if (!$(selectors.currency).length) {
      return;
    }

    try {
     // console.log(settings);
      // Saving the current price
      $(target).each(function() {
        $(this).attr("data-currency-" + settings.shop_currency, $(this).html());
      });

      // Update the price
      Currency.convertAll(
        settings.shop_currency,
        Currency.cookie.read(),
        target,
        settings.currency_format
      );
    } catch (err) {
      console.log(err.message);
    }
  }

  function init() {
    if (!$(selectors.currency).length) {
      return;
    }

   //  initCurrency();
    
    if ($(selectors.currency).hasClass('ml__js')) {
      _currencyJs();
    }
    else {
      _currencyLiquid();
    }
  }

  return {
    init: init,
    convert: currencyPicker
  };
})();

(function() {
  var selectors = {
    backButton: ".return-link"
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one("click", function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement("a");
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: "slideshow-wrapper",
    slideshow: "slideshow",
    slideshowWindow: "slideshow--window",
    imageBackground: "slideshow__image",
    currentSlide: "slick-current",
    video: "slideshow__video",
    videoBackground: "slideshow__video--background",
    closeVideoBtn: "slideshow__video-control--close",
    pauseButton: "slideshow__pause",
    isPaused: "is-paused"
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
    this.$pause = this.$wrapper.find("." + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data("autoplay"),
      autoplaySpeed: this.$slideshow.data("speed")
    };

    this.$slideshow.on("beforeChange", beforeChange.bind(this));
    this.$slideshow.on("init", slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on("click", this.togglePause.bind(this));

    //slideshowSpinner();
    slideshowWindowHeight();
  }

  function slideshowWindowHeight() {
    if (!$("." + classes.slideshowWindow).length) {
      return;
    }

    function setWindowHeight() {
      var w_height = $(window).height();
      $("." + classes.slideshowWindow).css("height", w_height);
    }

    setWindowHeight();

    $(window).on("resize", function() {
      setWindowHeight();
    });
  }

  function slideshowSpinner() {
    $("." + classes.imageBackground).bgLoaded({
      afterLoaded: function() {
        $("." + classes.wrapper).removeClass("loading").addClass("loaded");
        $("." + classes.wrapper).find(".tp-loader").hide();
      }
    });
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr("aria-live");

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on("focusin", function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr("aria-live", "polite");

      if (autoplay) {
        $slider.slick("slickPause");
      }
    });

    // Resume autoplay
    $wrapper.on("focusout", function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr("aria-live");

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick("slickPlay");
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on("keydown", function(evt) {
        if (evt.which === 37) {
          $slider.slick("slickPrev");
        }

        if (evt.which === 39) {
          $slider.slick("slickNext");
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find(".slick-active button").focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find("." + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find("." + classes.video);
      var currentVideoId = $currentVideo.attr("id");
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr("tabindex", "-1");
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find("." + classes.video);
      var videoId = $video.attr("id");
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr("tabindex", "0");
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find("." + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick("slickPlay");
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick("slickPause");
    }
  };

  function getSlideshowId($el) {
    return "#Slideshow-" + $el.data("id");
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    slideshowWrapper: "slideshow-wrapper",
    slide: "slideshow__slide",
    slideBackgroundVideo: "slideshow__slide--background-video",
    slideDots: "slick-dots",
    videoChrome: "slideshow__video--chrome",
    videoBackground: "slideshow__video--background",
    playVideoBtn: "slideshow__video-control--play",
    closeVideoBtn: "slideshow__video-control--close",
    currentSlide: "slick-current",
    slickClone: "slick-cloned",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay"
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr("id")] = {
      id: $video.attr("id"),
      videoId: $video.data("id"),
      type: $video.data("type"),
      status: $video.data("type") === "chrome" ? "closed" : "background", // closed, open, background
      videoSelector: $video.attr("id"),
      $parentSlide: $video.closest("." + classes.slide),
      $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
      controls: $video.data("type") === "background" ? 0 : 1,
      slideshow: $video.data("slideshow")
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === "function"
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $("#" + videoData.id).attr("tabindex", "-1");

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case "background-chrome":
      case "background":
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "background-chrome":
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case "chrome":
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return;
    }

    $("#" + videoData.id).attr("tabindex", "0");

    switch (videoData.type) {
      case "chrome":
      case "background-chrome":
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find("." + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === "background-chrome") {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== "closed" && videoData.type !== "background") {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === "chrome" && videoData.status === "closed") {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(" ");

    $("#" + videoData.id).attr("tabindex", "-1");

    videoData.status = "closed";

    switch (videoData.type) {
      case "background-chrome":
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case "chrome":
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = "open";

    switch (videoData.type) {
      case "background-chrome":
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case "chrome":
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on("keydown.videoPlayer", function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $("." + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest("." + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $("#" + playerId)
      .removeAttr("style")
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = "open";
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $("#" + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = "background";
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on("click.videoPlayer", "." + classes.playVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      startVideoOnClick(playerId);
    });

    $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      "resize.videoPlayer",
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off(".videoPlayer");
    $(window).off(".videoPlayer");
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $("#BlogTagFilter");

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on("change", function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $("#RecoverPassword").on("click", function(evt) {
      evt.preventDefault();
      $("#forgot-pass-tab").trigger("click");
    });

    // Hide reset password form
    $("#HideRecoverPasswordLink").on("click", function(evt) {
      evt.preventDefault();
      $("#login-tab").trigger("click");
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew"
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function() {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function() {
      $newAddressForm.toggleClass("hide");
    });

    $(".address-edit-toggle").on("click", function() {
      var formId = $(this).data("form-id");
      $("#EditAddress_" + formId).toggleClass("hide");
    });

    $(".address-delete").on("click", function() {
      var $el = $(this);
      var formId = $el.data("form-id");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )
      ) {
        Shopify.postLink("/account/addresses/" + formId, {
          parameters: { _method: "delete" }
        });
      }
    });
  }

  return {
    init: function() {
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.Search.init();
    theme.CurrencyPicker.init();
  }

  return Header;
})();


theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
          .then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
      .then(function(results) {
        var mapOptions = {
          mapTypeId: 'terrain',
          zoom: config.zoom,
          center: results[0].geometry.location,
          disableDefaultUI: true
        };

        var map = this.map = new google.maps.Map($map[0], mapOptions);
        var center = this.center = map.getCenter();
		// var icon_map = $('.map-section__container').data("icon_map");
        //eslint-disable-next-line no-unused-vars
        var marker = new google.maps.Marker({
          map: map,
          position: map.getCenter()
        //  icon: icon_map
        });

        google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        }));
      }.bind(this))
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = theme.strings.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = theme.strings.addressQueryLimit;
            break;
          default:
            errorMessage = theme.strings.addressError;
            break;
        }

        $map
        .parent()
        .addClass('map-section--load-error')
        .html('<div class="errors text-center">' + errorMessage + '</div>');
      });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = this.sectionId = $container.attr("data-section-id");
    var sectionType = $container.attr("data-section-type");
    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: false,
      enableHistoryState: $container.data("enable-history-state") || false,
      imageSize: null,
      namespace: ".slideshow-" + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      swatch_color: $container.attr("data-product_swatch_color"),
      swatch_color_advanced: $container.attr("data-product_swatch_color_advanced"),
      swatch_size: $container.attr("data-product_swatch_size"),
      product_design: $container.attr("data-product_design"),
      product_mobile_variant: $container.attr("data-product_mobile_variant")
    };

    this.selectors = {
      product: "#ProductSection-" + sectionId,
      addToCart: "#AddToCart-" + sectionId,
      addToCartText: "#AddToCartText-" + sectionId,
      stockText: ".stock-" + sectionId,
      comparePrice: "#ComparePrice-" + sectionId,
      originalPrice: "#ProductPrice-" + sectionId,
      SKU: ".variant-sku",
      originalPriceWrapper: ".product-price__price-" + sectionId,
      originalSelectorId: "#ProductSelect-" + sectionId,
      productFeaturedImage: ".FeaturedImage-" + sectionId,
      productImageWrap: "#FeaturedImageZoom-" + sectionId,
      productPrices: ".product-single__price-" + sectionId,
      productThumbImages: "#product-thumbnails-" + sectionId,
      productMainImages: "#product-images-" + sectionId,
      productPreviewMainImages: ".product-preview-images-" + sectionId,
      saleLabel: ".product-price__sale-label-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      singleOptionSelectorId: "#single-option-selector-" + sectionId,
      singleOptionSwatches: "tawcvs-swatches-" + sectionId,
      instagramProduct: "#product-instagram-" + sectionId,
      instagramProductNameSpace: "product-instagram-" + sectionId,
      variationsSelector: "#variations-" + sectionId,
      variationSelector: ".variation-select-" + sectionId,
      qtyVariant: ".qty-variant-" + sectionId,
      threedId: ".threed-id-" + sectionId, 
      countDownId: ".countdown-"+ sectionId, 
      couponCode: "#coupon-code-"+ sectionId, 
      couponBtn: "#coupon-btn-"+ sectionId,
      sidebarSlide: ".sidebar-slick-vertical-"+sectionId
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );
    this.productSwatchSingleObject = JSON.parse(document.getElementById('ProductSwatchJson-' + sectionId).innerHTML);
    //this._initBreakpoints();
    this._stringOverrides();
    this._initCountDown();
    this._initCoupon();
    this._initPopup();
    this._initVariants();
    this._initSwatches();
    this._initFeature();
    this._initCompact();
    this._initStickyImages();
    this._initThumbnailsGallery();
    this._initImages();
    this._initSidebar();
    this._initZoom();
    this._initGallery();
    this._initTab();
    this._initQuantity();
    this._initReviewTab();
    this._relatedProducts();
    this._recentlyViewed();
    this._instagramProducts();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },
    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // on mobile
        },
        unmatch: function() {}
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          // on desktop
        }
      });
    },
    _initPopup: function(){
      $('.sizechart-btn').magnificPopup({
        type:'image',
        midClick: true 
      });
      $(".return-btn").click(function(e) {
        return $.magnificPopup.open({
          items: { src: "#delivery-return", type: "inline" },
          tLoading: "",
          mainClass: "popup-wrapper mfp-with-zoom",
          removalDelay: 200
        }), !1;
      })
    },
    _initCoupon: function(){
      $(this.selectors.couponBtn).length > 0 && $(this.selectors.couponBtn).unbind('click') && $(this.selectors.couponBtn).click(function(){
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(this).data("coupon")).select();
        document.execCommand("copy");
        $temp.remove();
        jQuery("#rtp-message").html($(this).data("copied"));
        jQuery("#rt-unero-popup-message")
        .css(
          "margin-left",
          "-" + (parseFloat(jQuery("#rt-unero-popup-message").width()) / 2)  + "px"
        )
        .fadeIn();
        window.setTimeout(function() {
          jQuery("#rt-unero-popup-message").fadeOut();
        }, 2e3);
      })
    },
    _initCountDown: function() {
      if ($(this.selectors.countDownId).length <= 0) {
        return;
      }
      if ($().countdown && $(this.selectors.countDownId).length > 0) {
        if($(this.selectors.countDownId).data('countdown') != ''){
          var currentDay = new Date();
          var offerDay = $(this.selectors.countDownId).data('countdown').split('-');
          var offerDay = new Date( offerDay[2], (parseInt(offerDay[0]) - 1), offerDay[1] );
          if(currentDay < offerDay){
            $(this.selectors.countDownId).countdown({
              until: offerDay,
              layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'

            });
          }
        }
      }
    },
    _initFeature: function(){
      $(this.selectors.product + ' .product-video-button a').length >0 && $(this.selectors.product + ' .product-video-button a').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        disableOn: false,
        fixedContentPos: false
      });
      if($(this.selectors.product + ' .product-360-button a').length > 0) {
        var images_arr = Array(),
            jImages = JSON.parse(document.getElementById("threed-id-" + this.sectionId).innerHTML);
        for(var i = 1 ; i <= 72 ; i++) {
          var _key = "f" + i;
          if(jImages[_key]) {
            images_arr.push(jImages[_key]);
          }
        }
        if(images_arr.length > 0) {
          var frame_count = images_arr.length;
          $(this.selectors.threedId).ThreeSixty({
            totalFrames: frame_count,
            endFrame: frame_count, 
            currentFrame: 1, 
            imgList: '.threed-view-images', 
            progress: '.spinner',
            imgArray: images_arr,
            height: null,
            width: null,
            responsive: true,
            navigation: true,
            onReady: function () {
              $('.product-360-button a').magnificPopup({
                type: 'inline',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                disableOn: false,
                preloader: false,
                fixedContentPos: false,
                callbacks: {
                  open: function() {
                    $(window).resize()
                  },
                }

              });
            }
          });
        }
      }
    },
    _initCompact: function(){
      if($(".product-accordion").length >0){
        var $accordion = $(".product-accordion"),
            $items = $(".accordion-item");

        // Set heights on accordion items and titles on page load
        $items.each(function() {
          var $that = $(this),
              $title = $that.find(".title"),
              titleHeight = $title.innerHeight(),
              contentHeight = $that.find(".content").outerHeight(),
              $parent = $title.parent(".accordion-item");

          $title.data("height", titleHeight);
          $that.data("height", titleHeight + contentHeight);
        });

        $items.each(function() {
          var $that = $(this),
              $title = $that.find(".title"),
              titleHeight = $title.innerHeight(),
              contentHeight = $that.find(".content").outerHeight(),
              $parent = $title.parent(".accordion-item");

          $title.data("height", titleHeight);
          $that.data("height", titleHeight + contentHeight);

          if ($parent.hasClass("active")) {
            $parent.height($parent.data("height"));
          }
        });

        // Event for triggering accordion to show
        $accordion.on("click", ".accordion-item > .title", function() {
          var $that = $(this), $parent = $that.parent(".accordion-item");

          if (!$parent.hasClass("active")) {
            $items
            .closest(".active")
            .removeClass("active")
            .height($that.data("height"));
          }
          $parent.toggleClass("active");
          // Check if the item is active and set to saved height
          // on either title or item
          if ($parent.hasClass("active")) {
            $parent.height($parent.data("height"));
          } else {
            $parent.height($that.data("height"));
          }
        });
      }
    },
    _initStickyImages: function() {
      if( ! $('body').hasClass('unero-product-design-sticky') ) return;
      var details = $('.product-summary'),
          detailsInner = details.find('.entry-summary'),
          detailsWidth = details.width(),
          images = $('.unero-images'),
          thumbnails = images.find('.shopify-product-gallery__wrapper a'),
          offsetThumbnails,
          viewportHeight = $(window).height(),
          imagesHeight = images.outerHeight(),
          topOffset = 130,
          maxWidth = 600,
          innerWidth,
          detailsHeight = details.outerHeight(),
          scrollTop = $(window).scrollTop(),
          imagesTop =  images.offset().top,
          detailsLeft =  details.offset().left + 15,
          imagesBottom = imagesTop + imagesHeight,
          detailsBottom = scrollTop + topOffset + detailsHeight;


      details.css({
        height: detailsHeight
      });

      $(window).resize(function() {
        recalculate();
      });

      $(window).scroll(function() {
        onscroll();
        animateThumbnails();
      });

      images.imagesLoaded(function() {
        recalculate();
      });
      function animateThumbnails() {
        viewportHeight = $(window).height();
        thumbnails.each(function(){
          offsetThumbnails = $(this).offset().top;
          if(scrollTop > (offsetThumbnails - viewportHeight + 20)) {
            $(this).addClass('animate-images');
          }

        });
      }

      function onscroll() {
        scrollTop = $(window).scrollTop();
        detailsBottom = scrollTop + topOffset + detailsHeight;
        detailsWidth = details.width();
        detailsLeft =  details.offset().left + 15;
        imagesTop =  images.offset().top;
        imagesBottom = imagesTop + imagesHeight;

        if (detailsWidth > maxWidth) {
          innerWidth = (detailsWidth - maxWidth) / 2;
          detailsLeft = detailsLeft + innerWidth;
        }

        // Fix after scroll the header
        if( scrollTop + topOffset >= imagesTop ) {
          details.addClass('block-sticked');

          detailsInner.css({
            top: topOffset,
            left: detailsLeft,
            width: detailsWidth,
            position: 'fixed',
            transform:'translateY(-20px)'
          });
        } else {
          details.removeClass('block-sticked');
          detailsInner.css({
            top: 'auto',
            left: 'auto',
            width: 'auto',
            position: 'relative',
            transform:'translateY(0px)'
          });
        }
        // When rich the bottom line
        if( detailsBottom > (imagesBottom + 50)) {
          details.addClass('hide-temporary');
        } else {
          details.removeClass('hide-temporary');
        }
      };


      function recalculate() {
        viewportHeight = $(window).height();
        detailsHeight = details.outerHeight();
        imagesHeight = images.outerHeight();

        // If enought space in the viewport
        if( detailsHeight < ( viewportHeight - topOffset ) ) {
          details.addClass('in-viewport').removeClass('not-in-viewport');
        } else {
          details.removeClass('in-viewport').addClass('not-in-viewport');
        }
        onscroll();
        animateThumbnails();
      };

    },
    _initThumbnailsGallery:function(){
      var slickImages = $(this.selectors.productMainImages);
      this.settings.product_design == "gallery" && $('.thumbnail-gallery-item').on('click', function(){
        var _self = $(this);
        if(!_self.hasClass('active')){ 
          $('.thumbnail-gallery-item').removeClass("active");
          _self.addClass("active");
          $('.thumbnail-gallery-item').each(function(index){
            if($(this).attr('id') == _self.attr('id')){ slickImages.slick("slickGoTo", index, true);return };
          });
        }
      })
    },
    _instagramProducts: function() {
      if ($(this.selectors.instagramProduct).length > 0) {
        var self = $(this.selectors.instagramProduct),
          selfNamespace = this.selectors.instagramProductNameSpace,
          user_id = self.attr("data-id"),
          access_token = self.attr("data-token"),
          limit = self.attr("data-limit"),
          columns = self.data("per_view"),
          autoplay = self.data("auto"),
          infinite = false,
          speed = self.data("speed");

        var feed = new Instafeed({
          get: "user",
          target: selfNamespace,
          accessToken: access_token,
          userId: parseInt(user_id),
          limit: parseInt(limit),
          resolution: "standard_resolution",
          resolution2: "standard_resolution",
          template: '<li class="product"><a class="insta-item" target="_blank" href="{{link}}" style="background-image:url({{image}});"><i class="social_instagram"></i></a></li>',
          after: function() {
            if (autoplay > 0) {
              infinite = true;
              autoplay = true;
            } else {
              autoplay = false;
            }

            self.not(".slick-initialized").slick({
              slidesToShow: columns,
              slidesToScroll: 1,
              autoplaySpeed: speed,
              autoplay: autoplay,
              infinite: infinite,
              dots: false,
              prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
              nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                }
              ]
            });
          }
        });
        feed.run();
      }
    },
    _relatedProducts: function() {
      var self = $(this.selectors.product + " .related.products ul.products");
      self.length > 0 &&
        self.not(".slick-initialized").slick({
          slidesToShow: self.data("per_view"),
          slidesToScroll: self.data("per_view"),
          arrows: false,
          lazyLoad: "ondemand",
          dots: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
    },
    _recentlyViewed: function() {
      var self = $(this.selectors.product + " .viewed.products ul.products");
      var ls = Currency.cookie.rtread('rt-recent');
      var product_handle = $(".template-product .viewed.products").data("handle");
      var product_id = $(".template-product .viewed.products").data("id");
      if(ls != null){ 
        ls = ls.split(',');
        var ls = ls.reverse();
        if(ls.length > 1){
          $("#recently-viewed-products").show();
        } else if (ls != product_handle) {
          $("#recently-viewed-products").show();
        }
        $.ajax({
          url:  '/search?view=viewed&q='+ls+'_sp_'+product_id,
          dataType: 'html',
          type: 'GET',
          success: function(responsive) {
            $('#recently_wrap').html(responsive);
          },
          error: function(data) {
            console.log('ajax error');
          },
          complete: function() {
            theme.roarApplication.initLoadMore();
            theme.show_multiple_currencies && theme.CurrencyPicker.convert(".viewed.products .money");
            
            self.length > 0 &&
              self.not(".slick-initialized").slick({
              slidesToShow: self.data("per_view"),
              slidesToScroll: self.data("per_view"),
              arrows: false,
              lazyLoad: "ondemand",
              dots: true,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                }
              ]
            });
            $(".viewed.products").find("img.lazy").lazyload();
          }
        }); 
        if(ls.indexOf(product_handle)< 0 ){
          if(ls.length >= theme.viewed_limit){
            ls.pop();
          }
          ls.push(product_handle)
          try{ ls = ls.join(',');}catch(ex){}
        }
      }else{
        ls = product_handle;
      }
      Currency.cookie.rtwrite('rt-recent',ls);
    },
    _initReviewTab: function() {
      $(".rt-unero-product-rating").unbind("click");
      $(".rt-unero-product-rating").click(function() {
        $('a[href="#tab-reviews"]').length > 0 &&
          $('a[href="#tab-reviews"]').trigger(
            "click"
          ), $("html,body").animate({ scrollTop: $("#tab-reviews").offset().top }, "slow");
      });
    },
    _initQuantity: function() {
      var addCartVariant = $(this.selectors.addToCart);
      var qtyVariant = $(this.selectors.qtyVariant);
      $(".q_up").unbind("click");
      $(".q_up").click(function() {
        var p_id = $(this).data("product_id");
        var q_value = parseInt($(".qty-" + p_id).val()) + 1;
        $(".qty-" + p_id).val(q_value);
        if (qtyVariant.length > 0) {
          var r_disabled = false;
          qtyVariant.each(function() {
            var qtyVariantVal = parseInt($(this).val());
            var variant_id = $(this).data("variant_id");
            if (qtyVariantVal != 0) {
              r_disabled = true;
              $("form#cart-variant-form-" + variant_id).removeClass(
                "not-submit"
              );
            } else {
              !$("form#cart-variant-form-" + variant_id).hasClass(
                "not-submit"
              ) && $("form.variant-form-" + p_id).addClass("not-submit");
            }
          });
          if (r_disabled) {
            addCartVariant.removeClass("disabled");
          } else {
            !addCartVariant.hasClass("disabled") &&
              addCartVariant.addClass("disabled");
          }
        }
      });
      $(".q_down").unbind("click");
      $(".q_down").click(function() {
        var p_id = $(this).data("product_id");
        var q_value = parseInt($(".qty-" + p_id).val());
        if (qtyVariant.length > 0) {
          if (q_value > 0) {
            $(".qty-" + p_id).val(q_value - 1);
          }
          var r_disabled = false;
          qtyVariant.each(function() {
            var qtyVariantVal = parseInt($(this).val());
            var variant_id = $(this).data("variant_id");
            if (qtyVariantVal != 0) {
              r_disabled = true;
              $("form#cart-variant-form-" + variant_id).removeClass(
                "not-submit"
              );
            } else {
              !$("form#cart-variant-form-" + variant_id).hasClass(
                "not-submit"
              ) && $("form.variant-form-" + p_id).addClass("not-submit");
            }
          });
          if (r_disabled) {
            addCartVariant.removeClass("disabled");
          } else {
            !addCartVariant.hasClass("disabled") &&
              addCartVariant.addClass("disabled");
          }
        } else {
          if (q_value > 1) {
            $(".qty-" + p_id).val(q_value - 1);
          }
        }
      });
    },
    _initTab: function() {
      $(this.selectors.product + " .product-tabs")
        .off("click")
        .on("click", "ul.tabs li a", function(event) {
          event.preventDefault();

          if ($(this).parent("li").hasClass("active")) {
            return false;
          } else {
            var $tab = $(this);
            var $tabs_wrapper = $tab.closest(".product-tabs");
            var $tabs = $tabs_wrapper.find("ul.tabs");

            $tabs.find("li").removeClass("active");
            $(this).parent("li").addClass("active");

            $tabs_wrapper.find(".panel:visible").fadeOut(300, function() {
              $tabs_wrapper.find($tab.attr("href")).fadeIn(300);
            });

            return false;
          }
        });
    },
    _initGallery: function() {
      var initPhotoSwipeFromDOM = function(gallerySelector) {
        var parseThumbnailElements = function(el) {
          var thumbElements = $(el).find(".photoswipe-item").get(),
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;

          for (var i = 0; i < numNodes; i++) {
            figureEl = thumbElements[i];

            if (figureEl.nodeType !== 1) {
              continue;
            }

            linkEl = figureEl.children[0];
            size = linkEl.getAttribute("data-size").split("x");

            if ($(linkEl).data("type") == "video") {
              var video_html = $($(linkEl).data("id")).html();
              items.push({
                html: video_html
              });
            } else {
              item = {
                src: linkEl.getAttribute("href"),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
              };
              if (figureEl.children.length > 1) {
                item.title = $(figureEl).find(".caption").html();
              }

              if (linkEl.children.length > 0) {
                item.msrc = linkEl.children[0].getAttribute("src");
              }

              item.el = figureEl;
              items.push(item);
            }
          }

          return items;
        };

        var closest = function closest(el, fn) {
          return el && (fn(el) ? el : closest(el.parentNode, fn));
        };

        function hasClass(element, cls) {
          return (" " + element.className + " ").indexOf(" " + cls + " ") > -1;
        }

        var onThumbnailsClick = function(e) {
          e = e || window.event;
          e.preventDefault ? e.preventDefault() : (e.returnValue = false);

          var eTarget = e.target || e.srcElement;

          var clickedListItem = closest(eTarget, function(el) {
            return hasClass(el, "photoswipe-item");
          });

          if (!clickedListItem) {
            return;
          }

          var clickedGallery = clickedListItem.closest(".photoswipe-wrapper"),
            childNodes = $(clickedListItem.closest(".photoswipe-wrapper"))
              .find(".photoswipe-item")
              .get(),
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

          for (var i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
              continue;
            }

            if (childNodes[i] === clickedListItem) {
              index = nodeIndex;
              break;
            }
            nodeIndex++;
          }

          if (index >= 0) {
            openPhotoSwipe(index, clickedGallery);
          }
          return false;
        };

        var photoswipeParseHash = function() {
          var hash = window.location.hash.substring(1), params = {};

          if (hash.length < 5) {
            return params;
          }

          var vars = hash.split("&");
          for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
              continue;
            }
            var pair = vars[i].split("=");
            if (pair.length < 2) {
              continue;
            }
            params[pair[0]] = pair[1];
          }

          if (params.gid) {
            params.gid = parseInt(params.gid, 10);
          }

          return params;
        };

        var openPhotoSwipe = function(
          index,
          galleryElement,
          disableAnimation,
          fromURL
        ) {
          var pswpElement = document.querySelectorAll(".pswp")[0],
            gallery,
            options,
            items;

          items = parseThumbnailElements(galleryElement);

          options = {
            closeOnScroll: false,

            galleryUID: galleryElement.getAttribute("data-pswp-uid")
          };

          if (fromURL) {
            if (options.galleryPIDs) {
              for (var j = 0; j < items.length; j++) {
                if (items[j].pid == index) {
                  options.index = j;
                  break;
                }
              }
            } else {
              options.index = parseInt(index, 10) - 1;
            }
          } else {
            options.index = parseInt(index, 10);
          }

          if (isNaN(options.index)) {
            return;
          }

          if (disableAnimation) {
            options.showAnimationDuration = 0;
          }

          gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
          );
          gallery.init();

          gallery.listen("beforeChange", function() {
            var currItem = $(gallery.currItem.container);
            $(".pswp__video").removeClass("active");
            var currItemIframe = currItem
              .find(".pswp__video")
              .addClass("active");
            $(".pswp__video").each(function() {
              if (!$(this).hasClass("active")) {
                $(this).attr("src", $(this).attr("src"));
              }
            });
          });

          gallery.listen("close", function() {
            $(".pswp__video").each(function() {
              $(this).attr("src", $(this).attr("src"));
            });
          });
        };

        var galleryElements = document.querySelectorAll(gallerySelector);

        for (var i = 0, l = galleryElements.length; i < l; i++) {
          galleryElements[i].setAttribute("data-pswp-uid", i + 1);
          galleryElements[i].onclick = onThumbnailsClick;
        }

        var hashData = photoswipeParseHash();
        if (hashData.pid && hashData.gid) {
          openPhotoSwipe(
            hashData.pid,
            galleryElements[hashData.gid - 1],
            true,
            true
          );
        }
      };

      initPhotoSwipeFromDOM(this.selectors.product + " .photoswipe-wrapper");
    },
    _initZoom: function() {
      if ($(".easyzoom").length) {
        if ($(window).width() > 1024) {
          var $easyzoom = $(".easyzoom:not(.feature-video)").easyZoom({
            loadingNotice: "",
            errorNotice: "",
            preventClicks: false
          });

          var easyzoom_api = $easyzoom.data("easyZoom");
        } else {
          $(".easyzoom a").click(function(event) {
            event.preventDefault();
          });
        }
      }
    },
    _initImages: function() {
      var self = this;
      var $images = $(self.selectors.productMainImages);
      // thumbnails
      if (this.settings.product_design == 'left' 
          || this.settings.product_design == 'bottom'
          || this.settings.product_design == 'sidebar'
          || this.settings.product_design == 'full-screen') {
        if ($(self.selectors.productThumbImages).length > 0) {
          var $thumbnails = $(self.selectors.productThumbImages).find(
            ".thumbnails"
          );

          // Product thumnails and featured image slider
          $images.not(".slick-initialized").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: $thumbnails,
            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
          });
          
          var vertical =  ($(self.selectors.productThumbImages).data('vertical') == '0') ? false : true;
          $thumbnails.not(".slick-initialized").slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: $images,
            focusOnSelect: true,
            vertical: vertical,
            infinite: false,
            prevArrow: '<span class="icon-chevron-up slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-down slick-next-arrow"></span>'
          });
        }
      }else{
        if(this.settings.product_design == 'carousel'){
        // Product thumnails and featured image slider
        $images.not(".slick-initialized").slick({
          centerMode: true,
          centerPadding: '500px',
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
          nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
          responsive: [
            {
              breakpoint: 1680,
              settings: {
                centerMode: true,
                centerPadding: '400px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 1440,
              settings: {
                centerMode: true,
                centerPadding: '350px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 1200,
              settings: {
                centerMode: true,
                centerPadding: '300px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '250px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 992,
              settings: {
                centerMode: true,
                centerPadding: '200px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '125px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '50px',
                slidesToShow: 1
              }
            }
          ]
        });
        }else{
          // Product thumnails and featured image slider
          $images.not(".slick-initialized").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: $thumbnails,
            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
          });
        }
      }
      $images.imagesLoaded(function() {
        $images.addClass("loaded");
      });
      
    },
    _initSidebar: function() {
      var self = this; $sidebarSlide = $(self.selectors.sidebarSlide);
      $sidebarSlide.length > 0 && $sidebarSlide.each(function() {
        var _self = $(this);
       	var per_view = $(this).data('per_view');
        $(this).not(".slick-initialized").slick({
          slidesToShow: per_view,
          slidesToScroll: 1,
          vertical: true,
          focusOnSelect: true,
          infinite: false,
          prevArrow: '<span class="icon-chevron-up slick-prev-arrow"></span>',
          nextArrow: '<span class="icon-chevron-down slick-next-arrow"></span>'
        });
        _self.imagesLoaded(function() {
          _self.addClass("loaded");
        });
      });
    },
    _initForceHeight: function() {
      //Force height for images
      $(this.selectors.productPreviewMainImages).length > 0 &&
        $(this.selectors.productPreviewMainImages)
          .not(".slick-initialized")
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
          });
    },
    _initSwatches: function() {
      var _z = this.selectors.singleOptionSelectorId;
      function _processSwatchesImage(src) {
        let a_src = src.replace("https:", "").replace("http:", "").split("?v=")[0].split("/");
        let at_src = a_src[a_src.length - 1].split(".");
        let at_pop = at_src.pop(); 
        let t_src = at_src.join(".") + "_100x."+ at_pop;
        return src.replace(a_src[a_src.length - 1], t_src);
      }
      function swatchCallBack(e, op, ov) {
        for (i = 0; i < e.options.length; i++) {
          if(i != op) {
            $(_z +"-"+i+" option").each(function(){
              var _flag =  "unavailable";
              var _value = $(this).attr("value");

              for (j = 0; j < e.variants.length; j++) {
                var _variant = e.variants[j];
                if(_variant.options[op] == ov) {
                  // add out of stock or unavailable
                  if(_variant.options[i] == _value) {
                    if(_variant.available  == true) {
                      _flag =  "available";
                    }else{
                      _flag =  "sold_out";
                    }
                    break;
                  }
                }else{
                  continue;
                }
              }
              var iChek = "#swatch-"+i+"-" + _value.toLowerCase()
              .replace(/[^a-z0-9 -]/g, "")
              .replace(/\s+/g, "-")
              .replace(/-+/g, "-");
              $(iChek).removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(_flag);
            });
          }
        }

      }

      var e = this.productSingleObject;
      var sc = this.productSwatchSingleObject;
      var o = new Array();
      if (
        ((this.settings.swatch_size == "1" && o.push("Size"),o.push("size")), this.settings
          .swatch_color == "1" &&
          (o.push("Color"), o.push("Colour"),o.push("color"),o.push("colour")), o.length > 0)
      ) {
        var a = !1,
          n = !1,
          r = 0,
          s = theme.asset_url.substring(0, theme.asset_url.lastIndexOf("?")),
          c = theme.asset_url.substring(
            theme.asset_url.lastIndexOf("?"),
            theme.asset_url.length
          );
        for (i = 0; i < e.options.length; i++) {
          var l = "";
          var opps_content = "";
          var opps = "";
          var parent_swatch = "";
          var variant_selector = "";
          var f_active = "";
          var aswatch = "";
          var swatch_content= "";
          var swatch_label = "";
          if (
            ((l = "object" == typeof e.options[i]
              ? e.options[i].name
              : e.options[i]), (a = !1), (n = !1), o.indexOf(l) > -1)
          ) {
            (a = !0), (r = i);
            var d = l.toLowerCase();
            if ((/color|colour/i.test(d) && (n = !0), a)) {
              var u = "", m = new Array();
              for (j = 0; j < e.variants.length; j++) {
                var h = e.variants[j],
                  f = this.htmlEntities(h.options[r]),
                  g = this.convertToSlug(f),
                  _c = "available",
                  w = "swatch-" + r + "-" + g;
                m.indexOf(f) < 0 &&
                  (d != "color" && d != "colour"
                    ? (swatch_label = "swatch-label ")
                    : (swatch_label = ""), $(
                    this.selectors.singleOptionSelectorId + "-" + r
                  ).val() == f
                    ? (f_active = "selected ")
                    : (f_active = ""),
                    (d != "color" && d != "colour") ? (swatch_content = "background-color:" +f +"; background-image: url(" +s + g +".png" +c +")") : (this.settings.swatch_color_advanced == '1' ? (aswatch = "advanced", ( sc[g] !== null && sc[g] !== undefined && sc[g] != "" ? swatch_content = "background-image: url(" + s + sc[g] + ".png" + c + ")"  : ( h.featured_image !== null ? swatch_content = "background-image: url(" + _processSwatchesImage(h.featured_image.src) +")" : swatch_content = "background-color:" +f +"; background-image: url(" +s + g +".png" +c +")"))) : (aswatch = "", swatch_content = "background-color:" +f +"; background-image: url(" +s + g +".png" +c +")")),
                   (opps =  opps +
                    '<span id="swatch-'+r+'-'+g+'" data-id="' +
                    this.selectors.singleOptionSelectorId +
                    "-" +
                    r +
                    '" data-original-title="' +
                    f +
                    '" class="' +
                     _c + " "+                                                                                                     
                    f_active +
                    "swatch " +
                    aswatch + " "+                                                                                                     
                    swatch_label +
                    " swatch-" +
                    d +
                    " swatch-" +
                    f +
                    '" title="' +
                    f +
                    '" data-value="' +
                    f +
                    '" data-poption="'+r+'" style="'+swatch_content+'">'+f+
                    "<span class='soldout-image'></span><span class='unero-tooltip '><span class='unero-tooltip-label'>"+ f +"</span></span></span>"), m.push(f));
              }
              (opps_content =
                '<div class="' +
                this.selectors.singleOptionSwatches +
                ' tawcvs-swatches" data-attribute_name="attribute_pa_' +
                d +
                '">' +
                opps +
                "</div>"), (parent_swatch = $(
                this.selectors.singleOptionSelectorId + "-" + r
              )), (variant_selector = $(
                this.selectors.variationSelector + "-" + r
              )), opps_content != "" &&
                (parent_swatch.after(
                  opps_content
                ), parent_swatch.hide(), variant_selector.addClass(
                  "hide-choose-option"
                ));
            }
          }
        }
      }
      var thisSelector = "";
      $("." + this.selectors.singleOptionSwatches).length > 0 &&
        ((thisSelector = $(
          "." + this.selectors.singleOptionSwatches + " > span"
        )), thisSelector.unbind("click"), thisSelector.on("click", function() {
          var sId = $(this).data("id");
          var _poption = $(this).data("poption");
          var _val = $(this).data("value");
          $(this).data("value") != $(sId).val() &&
            ($(sId).val($(this).data("value")).trigger("change"), $(sId)
              .closest("td")
              .find("span.swatch")
              .removeClass("selected"), $(this).addClass("selected"));
         swatchCallBack(e, _poption, _val);
        }));
      $(".swatch.selected").trigger("click");
    },
    htmlEntities: function(e) {
      return String(e)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    convertToSlug: function (str) {
        str = str.toLowerCase();
    
        var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
        
        // For the old browsers
        for (var i = 0; i < toReplace.length; ++i) {
            str = str.replace(toReplace[i], "");
        }
    
        str = str.replace(/\W+/g, "-");
    
        if (str.charAt(str.length - 1) == "-") {
            str = str.replace(/-+\z/, "");
        }
    
        if (str.charAt(0) == "-") {
            str = str.replace(/\A-+/, "");
        }
    
        return str
    },
    convertToSlug1: function(v) {
      return v
        .replace('/','-')
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data("enable-history-state") ||
          false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        "variantSKUChange" + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },
    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass("invisible")
          .attr("aria-hidden", "true");

        if (variant.available) {
          $(".variations_button").removeClass("hide");
          $(this.selectors.addToCart)
            .prop("disabled", false)
            .toggleClass("hide", false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.stockText)
            .html(
              theme.strings.available +
                "<span>" +
                theme.strings.inStock +
                "</span>"
            )
            .removeClass("out-of-stock")
            .addClass("in-stock");
          if (
            variant.inventory_management == "shopify" &&
            variant.inventory_policy != "continue"
          ) {
            if (variant.inventory_quantity > 0 && (parseInt(theme.inventory) == 1)) {
              $(this.selectors.stockText).html(
                theme.strings.available +
                  "<span>"+variant.inventory_quantity+" "+theme.strings.inStock+"</span>"
              );
            }else{
            	$(this.selectors.stockText).html(
                theme.strings.available +
                  "<span>"+theme.strings.inStock+"</span>"
              );
            }
          }
        } else {
          $(".variations_button").addClass("hide");
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart)
            .prop("disabled", true)
            .toggleClass("hide", true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.stockText)
            .html(
              theme.strings.available +
                "<span>" +
                theme.strings.outStock +
                "</span>"
            )
            .removeClass("in-stock")
            .addClass("out-of-stock");
        }
      } else {
        $(".variations_button").addClass("hide");
        $(this.selectors.addToCart)
          .prop("disabled", true)
          .toggleClass("hide", true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.stockText)
          .html("<span>" + theme.strings.unavailable + "</span>")
          .removeClass("in-stock")
          .addClass("out-of-stock");
        $(this.selectors.productPrices)
          .addClass("invisible")
          .attr("aria-hidden", "false");
      }
    },
    _updateImages: function(evt) {
      var variant = evt.variant,
          self = this,
          product_design = this.settings.product_design,
          variant_image = variant.featured_image.src
      .replace("https:", "")
      .replace("http:", "")
      .split("?v=")[0];

      $(this.selectors.productFeaturedImage).each(function(index) {
        var _self = $(this),
            s_href = _self.attr("href");
        if (s_href.indexOf(variant_image) >= 0 && !_self.closest('.slick-slide').hasClass('slick-cloned')) {
          var slickImages = $(self.selectors.productMainImages);
          var pos =  _self.closest('.slick-slide').attr("data-slick-index");
          if(product_design == 'carousel') {
            slickImages.slick("slickGoTo", pos);
          }else{
            slickImages.slick("slickGoTo", pos, true);
          }
          if(product_design == 'scroll') {
            var s_top = parseInt(_self.closest(".shopify-product-gallery__image").offset().top) - 50;
            $("html,body").animate({ scrollTop: s_top}, "slow");
          }
          if(product_design == 'gallery') {
            $(".thumbnails .thumbnail-gallery-item").length > 0 && $(".thumbnails .thumbnail-gallery-item").each(function(){
              var img_src = $(this).data('href');
              if (img_src.indexOf(variant_image) >= 0) {
                $(this).trigger('click');
              }
            });
          }
          return;
        }
      });
    },
    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        '<span class="money">' +
          theme.Currency.formatMoney(variant.price, theme.moneyFormat) +
          "</span>"
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.productPrices).addClass("has-sale");
        $(this.selectors.productPrices).removeClass("not-sale");
        $(this.selectors.comparePrice)
          .html(
            '<span class="money">' +
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              ) +
              "</span>"
          )
          .removeClass("hide");

        $(this.selectors.saleLabel).find("span").text(theme.strings.sale);
        if (theme.sale_percentages != "") {
          var sale_percentages = Math.round(
            (variant.compare_at_price - variant.price) *
              100 /
              variant.compare_at_price
          );
          $(this.selectors.saleLabel)
            .find("span")
            .text("-" + sale_percentages + "%");
        }
        $(this.selectors.saleLabel).addClass("hide");
      } else {
        $(this.selectors.productPrices).removeClass("has-sale");
        $(this.selectors.productPrices).addClass("not-sale");
        $(this.selectors.comparePrice).addClass("hide");
        $(this.selectors.saleLabel).addClass("hide");
      }

      theme.show_multiple_currencies && theme.CurrencyPicker.convert(this.selectors.product + " .money");
    },
    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      if (variant.sku != "") {
        $(this.selectors.SKU)
          .removeClass("hide")
          .find(".sku")
          .text(variant.sku);
      } else {
        $(this.selectors.SKU).addClass("hide");
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  return Product;
})();

theme.Cart = (function() {
  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.cartId = $("#shopify-section-" + sectionId);
    this.cart = $("#cart-" + sectionId);
    this.cartNamespace = "#cart-" + sectionId;
    this._init();
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    _init: function() {
      Shopify.Cart.ShippingCalculator.show( {
        submitButton: theme.strings.shippingCalcSubmitButton,
        submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
        customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
        moneyFormat: theme.strings.shippingCalcMoneyFormat                                     
      } );
      this._initQuantity();
    },
    _initQuantity: function() {
      $(".q_up").unbind("click");
      $(".q_up").click(function() {
        var p_id = $(this).data("product_id");
        var q_value = parseInt($(".qty-" + p_id).val()) + 1;
        $(".qty-" + p_id).val(q_value);
      });
      $(".q_down").unbind("click");
      $(".q_down").click(function() {
        var p_id = $(this).data("product_id");
        var q_value = parseInt($(".qty-" + p_id).val());
        if (q_value > 1) {
          $(".qty-" + p_id).val(q_value - 1);
        }
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.cartNamespace);
    }
  });
  return Cart;
})();

theme.SearchTemplate = (function() {
  function SearchTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.SearchId = $("#search-" + sectionId);
    this.Search = $("#search-" + sectionId);
    this.SearchNamspace = "#search-" + sectionId;
    this.collection_infinite_scoll = this.Search.data(
      "collection_infinite_scoll"
    );
    this.collection_infinite_scoll_auto = this.Search.data(
      "collection_infinite_scoll_auto"
    );
    this.pInfScrLoading = false;
    this.pInfScrMore = true;
    this.flagScroll = true;
    this._init();
  }

  SearchTemplate.prototype = _.assignIn({}, SearchTemplate.prototype, {
    _init: function() {
      this._initCollectionControl();
    },
    _initCollectionControl: function() {
      var thisCT = this;
      if (this.collection_infinite_scoll == "1") {
        if (this.collection_infinite_scoll_auto == "1") {
          $(window).scroll(function() {
            var $elem = $(".load_more");
            if ($elem.length > 0) {
              var $window = $(window);

              var docViewTop = $window.scrollTop();
              var docViewBottom = docViewTop + $window.height();

              var elemTop = $elem.offset().top;
              var elemBottom = elemTop + $elem.height();

              if (
                elemBottom <= docViewBottom &&
                elemTop >= docViewTop &&
                thisCT.flagScroll
              ) {
                thisCT.flagScroll = false;
                $elem.find("a").trigger("click");
              }
            }
          });
        }
        jQuery(".load_more a").click(function(event) {
          thisCT._pInfScrExecute();
          event.stopPropagation();
          return false;
        });
      }
    },
    _pInfScrExecute: function() {
      var thisCT = this;
      var pInfScrNode = $(".load_more").last();
      var pInfScrURL = $(".load_more a").last().attr("href");
      if (pInfScrNode.length > 0 && thisCT.pInfScrMore) {
        $.ajax({
          type: "GET",
          url: pInfScrURL,
          beforeSend: function() {
            jQuery(".load_more").hide();
            jQuery("#un-products-loading").toggleClass("hide").fadeIn();
          },
          success: function(data) {
            var filteredData = jQuery(data).find(".products .product");
            jQuery(".products").append(filteredData);
            jQuery("#un-products-loading").toggleClass("hide").fadeOut();
            $(document.body).find("img.lazy").lazyload();
            if (jQuery(data).find(".load_more a").length) {
              jQuery(".load_more a")
                .last()
                .attr(
                  "href",
                  jQuery(data).find(".load_more a").last().attr("href")
                );
              jQuery(".load_more").show();
              thisCT.flagScroll = true;
              // update offset page
              var current_page = parseInt(
                jQuery(data).find(".load_more a").last().data("page")
              );
              if (current_page > 0) {
                var page_size = parseInt(
                  $(".page-num-offset").data("page_size")
                );
                var total_display = parseInt(
                  $(".page-num-offset").data("total_result")
                );
                var total_displayed = current_page * page_size;
                if (total_display > total_displayed) {
                  $(".result-offset")
                    .html(total_displayed)
                    .css("padding-right", "5px");
                }
              } else {
                $(".page-num-offset").html(
                  $(".page-num-offset").data("total_result")
                );
              }
            } else {
              thisCT.pInfScrMore = false;
              jQuery(".load_more").remove();
              $(".page-num-offset").html(
                $(".page-num-offset").data("total_result")
              );
            }
            thisCT._initReviews();
            thisCT._initCountDown();
            $('[data-toggle="tooltip"]').tooltip();
            theme.show_multiple_currencies && theme.CurrencyPicker.convert(".un-shop-content .money");
          },
          dataType: "html"
        });
      }
    },
    _initCountDown:function () {
      $().countdown && $('.countdown-item:not(.is-countdown)').length > 0 && $('.countdown-item:not(.is-countdown)').each(function(){
        if($(this).data('countdown') != ''){
          var currentDay = new Date();
          var offerDay = $(this).data('countdown').split('-');
          var offerDay = new Date( offerDay[2], (parseInt(offerDay[0]) - 1), offerDay[1] );
          if(currentDay < offerDay){
            $(this).countdown({
              until: offerDay,
              layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'

            });
          }
        }
      });
    },
    _initReviews: function() {
      "undefined" != typeof SPR &&
        (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
    },
    onUnload: function(evt) {
      this.$container.off(this.SearchNamspace);
    }
  });
  return SearchTemplate;
})();

theme.footerSection = (function() {
  function footerSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.footerId = $("#shopify-section-" + sectionId);
    this.footer = $("#site-" + sectionId);
    this.footerNamespace = "#site-" + sectionId;
    this.footerNewsletterForm = $("#mc-form-" + sectionId);
    this.footerKlaviyoForm = $("#email_signup_footer");
    this._init();
  }

  footerSection.prototype = _.assignIn({}, footerSection.prototype, {
    _init: function() {
      this._initFooter();
      this.footerNewsletterForm.length > 0 && this._initMailChimp();
      this.footerKlaviyoForm.length > 0 && this._initKlaviyo();
    },
    _initFooter: function() {
      var _parallax = $("#site-footer").data('parallax');
      if (_parallax == '1') {
        $(document.body).removeClass("footer-no-parallax").addClass("footer-parallax");
        $(window)
        .on("resize", function() {
          var fHeight = $("#site-footer .footer-layout").outerHeight(true);
          $(document.body).css("padding-bottom", fHeight);
          if ($(document.body).hasClass("page-header-layout-3")) {
            if ($(".page-header").data("parallax") == "1") {
              $("#site-footer").addClass("has-parallax");
              var hHeader = $(".page-header").height();
              $(window).on("scroll", function() {
                if ($(window).scrollTop() > hHeader) {
                  $("#site-footer").addClass("active");
                } else {
                  $("#site-footer").removeClass("active");
                }
              });
            }
          }
        })
        .trigger("resize");
      }else{
        $(document.body).removeClass("footer-parallax").addClass("footer-no-parallax");
      }
      
    },
    _initKlaviyo : function() {
      KlaviyoSubscribe.attachToForms('#email_signup_footer', {
        hide_form_on_success: true,
        success: function (e) {
          jQuery("#rtp-message").html(e.msg);
          jQuery("#rt-unero-popup-message")
          .css(
            "margin-left",
            "-" + (parseFloat(jQuery("#rt-unero-popup-message").width()) / 2)  + "px"
          )
          .fadeIn();
          window.setTimeout(function() {
            jQuery("#rt-unero-popup-message").fadeOut();
          }, 2e3);
        }
      });
    },
    _initMailChimp: function() {
      var n = this.footerNewsletterForm,
          r = n.attr("action");
      n.ajaxChimp({
        url: r,
        callback: function(e) {
          if(e.result =='success') {
            jQuery("#rtp-message").html(e.msg);
            jQuery("#rt-unero-popup-message")
            .css(
              "margin-left",
              "-" + (parseFloat(jQuery("#rt-unero-popup-message").width()) / 2)  + "px"
            )
            .fadeIn();
            window.setTimeout(function() {
              jQuery("#rt-unero-popup-message").fadeOut();
            }, 2e3);
            n.find(".mc4wp-response").removeClass('error').hide();
          }else{
            n.find(".mc4wp-response").addClass('error').html(e.msg).show();
          }
        }
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.footerNamespace);
    }
  });
  return footerSection;
})();

theme.sideBarSection = (function() {
  function sideBarSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.sidebarId = $("#shopify-section-" + sectionId);
    this.sidebar = $("#menu-sidebar-" + sectionId);
    this.sidebarNamespace = "#menu-sidebar-" + sectionId;
    this._init();
  }

  sideBarSection.prototype = _.assignIn({}, sideBarSection.prototype, {
    _init: function() {
      this._initMenu();
    },
    _initMenu: function() {
      $(".sidebar-child-menu").unbind("click");
      $(".sidebar-child-menu").click(function(e) {
        e.preventDefault();
        $(this).closest("li").siblings().find("ul").slideUp();
        $(this).closest("li").siblings().removeClass("active");
        $(this).closest("li").siblings().find("li").removeClass("active");

        $(this).closest("li").children("ul").slideToggle();
        $(this).closest("li").toggleClass("active");
        $(this).toggleClass("active");
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.sidebarNamespace);
    }
  });
  return sideBarSection;
})();

theme.mobileNavSection = (function() {
  function mobileNavSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.mobileNavId = $("#shopify-section-" + sectionId);
    this.mobileNav = $("#primary-" + sectionId);
    this.mobilenavNamespace = "#primary-" + sectionId;
    this._init();
  }

  mobileNavSection.prototype = _.assignIn({}, mobileNavSection.prototype, {
    _init: function() {
      this._initMobile();
    },
    _initMobile: function() {
      var $mobileMenu = this.mobileNav;
      $("#header-header").on("click", "#un-navbar-toggle", function(e) {
        e.preventDefault();
        $mobileMenu.toggleClass("open");
        $(document.body).toggleClass("open-canvas-panel");
      });
      $mobileMenu.on(
        "click",
        ".mobile-child-menu",
        function(e) {
          e.preventDefault();

          $(this).closest("li").siblings().find("ul").slideUp();
          $(this).closest("li").siblings().removeClass("active");
          $(this).closest("li").siblings().find("li").removeClass("active");

          $(this).closest("li").children("ul").slideToggle();
          $(this).closest("li").toggleClass("active");
        }
      );
	  $('.mobile-nav-footer').length > 0 && $('.mobile-nav-footer').on(
        "click",
        ".toggle-children",
        function(e) {
          e.preventDefault();

          $(this).closest("li").siblings().find("ul").slideUp();
          $(this).closest("li").siblings().removeClass("active");
          $(this).closest("li").siblings().find("li").removeClass("active");

          $(this).closest("li").children("ul").slideToggle();
          $(this).closest("li").toggleClass("active");
        }
      );
      $mobileMenu.on("click", ".close-canvas-mobile-panel", function(e) {
        e.preventDefault();
        closeCanvasPanel();
      });

      $(window).on("resize", function() {
        if ($(window).width() > 991) {
          if ($mobileMenu.hasClass("open")) {
            $mobileMenu.removeClass("open");
            $(document.body).removeClass("open-canvas-panel");
          }
        }
      });
      function closeCanvasPanel() {
        $(document.body).removeClass("open-canvas-panel");
        $(".unero-off-canvas-panel, #primary-mobile-nav").removeClass("open");
      }
    },

    onUnload: function(evt) {
      this.$container.off(this.mobilenavNamespace);
    }
  });
  return mobileNavSection;
})();
theme.CollectionTemplate = (function() {
  function CollectionTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.CollectionId = $("#collection-" + sectionId);
    this.Collection = $("#collection-" + sectionId);
    this.CollectionNamspace = "#collection-" + sectionId;
    this.collection_infinite_scoll = this.Collection.data(
      "collection_infinite_scoll"
    );
    this.collection_infinite_scoll_auto = this.Collection.data(
      "collection_infinite_scoll_auto"
    );
    this._init();
  }

  CollectionTemplate.prototype = _.assignIn({}, CollectionTemplate.prototype, {
    _init: function() {
      this._initCollectionFilter();
    },
    _initCollectionFilter: function() {
      // scroll mansory

      $(".shop-bottombar").length > 0 &&
        $(window)
          .on("scroll", function() {
            if ($(document.body).find("#un-shop-footer").is(":in-viewport")) {
              $(".shop-bottombar").find(".un-filter").addClass("not-viewport");
            } else {
              $(".shop-bottombar")
                .find(".un-filter")
                .removeClass("not-viewport");
            }
          })
          .trigger("scroll");

      // filter element click
      $("body").on("click", ".wc-layered-nav-term a", function(e) {
        var e = $(this).parent(), t = $(this).data("value"), o = [];
        if (
          (Shopify.queryParams.constraint &&
            (o = Shopify.queryParams.constraint.split(
              "+"
            )), !window.enable_filter_multiple_choice && !e.hasClass("chosen"))
        ) {
          var a = e.parents(".wc-layered-nav-term").find(".chosen");
          a.length > 0 &&
            a.each(function() {
              var e = $(this).data("handle");
              if (($(this).removeClass("chosen"), e)) {
                var t = o.indexOf(e);
                t >= 0 && o.splice(t, 1);
              }
            });
        }
        if (t) {
          var i = o.indexOf(t);
          0 > i
            ? (o.push(t), e.addClass("chosen"))
            : (o.splice(i, 1), e.removeClass("chosen"));
        }
        o.length
          ? (Shopify.queryParams.constraint = o.join("+"))
          : delete Shopify.queryParams.constraint, filterAjaxClick();
      });
      // paging click
      $("body").on("click", ".rt-unero-pagination a", function(e) {
        var t = $(this);
        delete Shopify
          .queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, delete Shopify.queryParams.sort_by, filterAjaxClick(t.attr("href")), e.preventDefault();
      });
      // order
      $("body").on("click", ".rt-unero-ordering a", function(e) {
        var t = $(this);
        var o = t.data("sort");
        $(".rt-unero-ordering a").removeClass("active");
        t.addClass("active");
        (Shopify.queryParams.sort_by = o), filterAjaxClick(), e.preventDefault();
      });
      // tags
      $("body").on("click", "#unero_product_tag_cloud a", function(e) {
        var e = $(this), t = $(this).data("value"), o = [];
        if (
          (Shopify.queryParams.constraint &&
            (o = Shopify.queryParams.constraint.split(
              "+"
            )), !window.enable_filter_multiple_choice &&
            !e.hasClass("selected"))
        ) {
          var a = e.parents(".tagcloud").find(".selected");
          a.length > 0 &&
            a.each(function() {
              var e = $(this).data("handle");
              if (($(this).removeClass("selected"), e)) {
                var t = o.indexOf(e);
                t >= 0 && o.splice(t, 1);
              }
            });
        }
        if (t) {
          var i = o.indexOf(t);
          0 > i
            ? (o.push(t), e.addClass("selected"))
            : (o.splice(i, 1), e.removeClass("selected"));
        }
        o.length
          ? (Shopify.queryParams.constraint = o.join("+"))
          : delete Shopify.queryParams.constraint, filterAjaxClick();
      });

      // event for load more and infinite scroll
      if (this.collection_infinite_scoll == "1") {
        var pInfScrLoading = false, pInfScrMore = true, flagScroll = true;
        if (this.collection_infinite_scoll_auto == "1") {
          $(window).scroll(function() {
            var $elem = $(".load_more");
            if ($elem.length > 0) {
              var $window = $(window);

              var docViewTop = $window.scrollTop();
              var docViewBottom = docViewTop + $window.height();

              var elemTop = $elem.offset().top;
              var elemBottom = elemTop + $elem.height();

              if (
                elemBottom <= docViewBottom &&
                elemTop >= docViewTop &&
                flagScroll
              ) {
                flagScroll = false;
                $elem.find("a").trigger("click");
              }
            }
          });
        }
        $("body").on("click", ".load_more a", function(event) {
          _pInfScrExecute();
          event.stopPropagation();
          return false;
        });
      }
      $("body").on("click", "#remove-filter-actived", function(e) {
        delete Shopify
          .queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, filterAjaxClick(), e.preventDefault();
      });

      function _pInfScrExecute() {
        var pInfScrNode = $(".load_more").last();
        var pInfScrURL = $(".load_more a").last().attr("href");
        if (pInfScrNode.length > 0 && pInfScrMore) {
          $.ajax({
            type: "GET",
            url: pInfScrURL,
            beforeSend: function() {
              jQuery(".load_more").hide();
              jQuery("#un-products-loading").toggleClass("hide").fadeIn();
            },
            success: function(data) {
              var $products = jQuery(".products");
              var filteredData = jQuery(data).find(".products .product");
              if ($(document.body).hasClass("catalog-board-content") || $(document.body).hasClass("collection-metro-content")) {
                filteredData.imagesLoaded(function() {
                  $products.isotope("insert", filteredData);
                  theme.roarApplication.initLoadMore();
                });
              } else {
                $products.append(filteredData);
                theme.roarApplication.initLoadMore();
              }

              jQuery("#un-products-loading").toggleClass("hide").fadeOut();
              $(document.body).find("img.lazy").lazyload();
              if (jQuery(data).find(".load_more a").length) {
                jQuery(".load_more a")
                  .last()
                  .attr(
                    "href",
                    jQuery(data).find(".load_more a").last().attr("href")
                  );
                jQuery(".load_more").show();
                flagScroll = true;
                // update offset page
                var current_page = parseInt(
                  jQuery(data).find(".load_more a").last().data("page")
                );
                if (current_page > 0) {
                  var page_size = parseInt(
                    $(".page-num-offset").data("page_size")
                  );
                  var total_display = parseInt(
                    $(".page-num-offset").data("total_result")
                  );
                  var total_displayed = current_page * page_size;
                  if (total_display > total_displayed) {
                    $(".result-offset")
                      .html(total_displayed)
                      .css("padding-right", "5px");
                  }
                } else {
                  $(".page-num-offset").html(
                    $(".page-num-offset").data("total_result")
                  );
                }
              } else {
                pInfScrMore = false;
                jQuery(".load_more").remove();
                $(".page-num-offset").html(
                  $(".page-num-offset").data("total_result")
                );
              }

              theme.show_multiple_currencies && theme.CurrencyPicker.convert(".un-shop-content .money");
            },
            dataType: "html"
          });
        }
      }

      function filterAjaxClick(e) {
        delete Shopify.queryParams.page;
        var t = filterCreateUrl(e);
        filterGetContent(t);
      }
      function filterCreateUrl(e) {
        var t = $.param(Shopify.queryParams).replace(/%2B/g, "+");
        return e ? "" != t ? e + "?" + t : e : location.pathname + "?" + t;
      }
      function filterGetContent(e) {
        var $container = $("#un-shop-content"),
          $container_nav = $("#primary-sidebar"),
          $container_offcanvas = $("#primary-offcanvas"),
          $categories = $("#un-categories-filter"),
          $shopTopbar = $("#un-shop-topbar"),
          $productFound = $(".product-found > span"),
          $ordering = $(".shop-toolbar .rt-unero-ordering");

        if ($("#un-shop-toolbar").length > 0) {
          var position = $("#un-shop-toolbar").offset().top - 200;
          $("html, body").stop().animate({ scrollTop: position }, 1200);
        }
        $("#un-shop-loading").addClass("show");
        $.ajax({
          type: "get",
          url: e,
          beforeSend: function() {
            if (
              $("#un-shop-toolbar").hasClass("on-mobile") ||
              $("#un-shop-topbar").hasClass("on-mobile")
            ) {
              $("#un-categories-filter").slideUp();
              $("#un-shop-topbar").slideUp();

              $("#un-toggle-cats-filter").removeClass("active");
              $(".un-filter").removeClass("active");
            }
          },
          success: function(res) {
            var o = 0;
            $container.replaceWith($(res).find("#un-shop-content"));
            $container_nav.html($(res).find(".catalog-sidebar").html());
            $container_offcanvas.html($(res).find(".catalog-offcanvas").html());
            $categories.html($(res).find("#un-categories-filter").html());
            $shopTopbar.html($(res).find("#un-shop-topbar").html());
            $productFound.html($(res).find(".product-found > span").html());
            $ordering.html(
              $(res).find(".shop-toolbar .rt-unero-ordering").html()
            );
            if ("?" == e.slice(-1)) {
              e = e.slice(0, -1);
            }
            e = e.replace(/%2C/g, ",");
            history.pushState(null, null, e);
            theme.roarApplication.initLoadMore();
            pInfScrMore = true;
            flagScroll = true;
            theme.show_multiple_currencies && theme.CurrencyPicker.convert(".un-shop-content .money");
            $("#un-shop-loading").removeClass("show");
            if ($(".wc-layered-nav-term.chosen").length > 0) {
              $("#remove-filter-actived").removeClass("hide");
            } else {
              $("#remove-filter-actived").addClass("hide");
            }
          },
          error: function() {
            $("#un-shop-loading").removeClass("show");
          }
        });
      }
    },
    _initReviews: function() {
      "undefined" != typeof SPR &&
        (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
    },
    onUnload: function(evt) {
      this.$container.off(this.SearchNamspace);
    }
  });
  return CollectionTemplate;
})();

theme.CollectionInstagramTemplate = (function() {
  function CollectionInstagramTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.collectionId = $("#shopify-section-" + sectionId);
    this.collection = $("#collection-" + sectionId);
    this.collectionNamespace = "#collection-" + sectionId;
    this._init();
  }

  CollectionInstagramTemplate.prototype = _.assignIn(
    {},
    CollectionInstagramTemplate.prototype,
    {
      _init: function() {
        this._initInstafeed();
      },
      _initInstafeed: function() {
        var instagram_target = "shop-instagram-" + this.sectionId;
        var token = this.collection.data("token");
        var user_id = this.collection.data("id");
        var limit = this.collection.data("limit");
        var feed = new Instafeed({
          get: "user",
          target: instagram_target,
          accessToken: token,
          userId: user_id,
          limit: limit,
          resolution: "standard_resolution",
          resolution2: "standard_resolution",
          template: '<div class="wrap animated"><a class="fauximg-bin" target="_blank" href="{{link}}"><figure class="snpt__fauximg" style="background-image: url({{image}})"></figure><i class="t-icon icon-bag2 snptlinked-item-ico"></i></a><div class="snptcrd__ovrly"><div class="ovrly_content snpt-atm sfx-scale-up"><div class="snpt-atm-el sfx__animated"><div class="snptcrd__button"><i class="t-icon icon-bag2"></i></div></div></div></div></div>'
        });
        feed.run();
      },
      onUnload: function(evt) {
        this.$container.off(this.collectionNamespace);
      }
    }
  );
  return CollectionInstagramTemplate;
})();

theme.CollectionsTemplate = (function() {
  function CollectionsTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.CollectionsId = $("#shopify-section-" + sectionId);
    this.Collections = $("#unero-site-content");
    this.CollectionsNamspace = "#unero-site-content";
    this.collection_infinite_scoll = this.Collections.data(
      "collection_infinite_scoll"
    );
    this.collection_infinite_scoll_auto = this.Collections.data(
      "collection_infinite_scoll_auto"
    );
    this.pInfScrLoading = false;
    this.pInfScrMore = true;
    this.flagScroll = true;
    this._init();
  }

  CollectionsTemplate.prototype = _.assignIn(
    {},
    CollectionsTemplate.prototype,
    {
      _init: function() {
        this._initCollectionControl();
      },
      _initCollectionControl: function() {
        var thisCT = this;
        if (this.collection_infinite_scoll == "1") {
          if (this.collection_infinite_scoll_auto == "1") {
            $(window).scroll(function() {
              var $elem = $(".load_more");
              if ($elem.length > 0) {
                var $window = $(window);

                var docViewTop = $window.scrollTop();
                var docViewBottom = docViewTop + $window.height();

                var elemTop = $elem.offset().top;
                var elemBottom = elemTop + $elem.height();

                if (
                  elemBottom <= docViewBottom &&
                  elemTop >= docViewTop &&
                  thisCT.flagScroll
                ) {
                  thisCT.flagScroll = false;
                  $elem.find("a").trigger("click");
                }
              }
            });
          }
          jQuery(".load_more a").click(function(event) {
            thisCT._pInfScrExecute();
            event.stopPropagation();
            return false;
          });
        }
      },
      _pInfScrExecute: function() {
        var thisCT = this;
        var pInfScrNode = $(".load_more").last();
        var pInfScrURL = $(".load_more a").last().attr("href");
        if (pInfScrNode.length > 0 && thisCT.pInfScrMore) {
          $.ajax({
            type: "GET",
            url: pInfScrURL,
            beforeSend: function() {
              jQuery(".load_more").hide();
              jQuery("#un-products-loading").toggleClass("hide").fadeIn();
            },
            success: function(data) {
              var content = $(data)
                .find(".unero-post-list")
                .children(".un-post-item");
              content.imagesLoaded(function() {
                $(".unero-post-list")
                  .append(content)
                  .isotope("insert", content);
              });

              jQuery("#un-products-loading").toggleClass("hide").fadeOut();
              $(document.body).find("img.lazy").lazyload();
              if (jQuery(data).find(".load_more a").length) {
                jQuery(".load_more a")
                  .last()
                  .attr(
                    "href",
                    jQuery(data).find(".load_more a").last().attr("href")
                  );
                jQuery(".load_more").show();
                thisCT.flagScroll = true;
                // update offset page
                var current_page = parseInt(
                  jQuery(data).find(".load_more a").last().data("page")
                );
                if (current_page > 0) {
                  var page_size = parseInt(
                    $(".page-num-offset").data("page_size")
                  );
                  var total_display = parseInt(
                    $(".page-num-offset").data("total_result")
                  );
                  var total_displayed = current_page * page_size;
                  if (total_display > total_displayed) {
                    $(".result-offset")
                      .html(total_displayed)
                      .css("padding-right", "5px");
                  }
                } else {
                  $(".page-num-offset").html(
                    $(".page-num-offset").data("total_result")
                  );
                }
              } else {
                thisCT.pInfScrMore = false;
                jQuery(".load_more").remove();
                $(".page-num-offset").html(
                  $(".page-num-offset").data("total_result")
                );
              }
            },
            dataType: "html"
          });
        }
      },
      _initReviews: function() {
        "undefined" != typeof SPR &&
          (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
      },
      onUnload: function(evt) {
        this.$container.off(this.CollectionsNamspace);
      }
    }
  );
  return CollectionsTemplate;
})();

theme.BlogTemplate = (function() {
  function BlogTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.BlogId = $("#shopify-section-" + sectionId);
    this.Blog = $("#unero-site-content");
    this.BlogNamspace = "#unero-site-content";
    this.collection_infinite_scoll = this.Blog.data(
      "collection_infinite_scoll"
    );
    this.collection_infinite_scoll_auto = this.Blog.data(
      "collection_infinite_scoll_auto"
    );
    this.sidebar = this.Blog.data(
      "sidebar"
    );
    this.pInfScrLoading = false;
    this.pInfScrMore = true;
    this.flagScroll = true;
    this._init();
  }

  BlogTemplate.prototype = _.assignIn(
    {},
    BlogTemplate.prototype,
    {
      _init: function() {
        this._initCollectionControl();
        this.sidebar != "" && $(document.body).removeClass("full-content").addClass(this.sidebar);
      },
      _initCollectionControl: function() {
        var thisCT = this;
        if (this.collection_infinite_scoll == "1") {
          if (this.collection_infinite_scoll_auto == "1") {
            $(window).scroll(function() {
              var $elem = $(".load_more");
              if ($elem.length > 0) {
                var $window = $(window);

                var docViewTop = $window.scrollTop();
                var docViewBottom = docViewTop + $window.height();

                var elemTop = $elem.offset().top;
                var elemBottom = elemTop + $elem.height();

                if (
                  elemBottom <= docViewBottom &&
                  elemTop >= docViewTop &&
                  thisCT.flagScroll
                ) {
                  thisCT.flagScroll = false;
                  $elem.find("a").trigger("click");
                }
              }
            });
          }
          jQuery(".load_more a").click(function(event) {
            thisCT._pInfScrExecute();
            event.stopPropagation();
            return false;
          });
        }
      },
      _pInfScrExecute: function() {
        var thisCT = this;
        var pInfScrNode = $(".load_more").last();
        var pInfScrURL = $(".load_more a").last().attr("href");
        if (pInfScrNode.length > 0 && thisCT.pInfScrMore) {
          $.ajax({
            type: "GET",
            url: pInfScrURL,
            beforeSend: function() {
              jQuery(".load_more").hide();
              jQuery("#un-products-loading").toggleClass("hide").fadeIn();
            },
            success: function(data) {
              var content = $(data)
              .find(".unero-post-list")
              .children(".un-post-item");
              if($('#unero-site-content').hasClass('blog-layout-masonry')) {
                content.imagesLoaded(function() {
                  $(".unero-post-list")
                  .append(content)
                  .isotope("insert", content);
                });
              } else {
                $(".unero-post-list").append(content);
              }
              
              jQuery("#un-products-loading").toggleClass("hide").fadeOut();
              $(document.body).find("img.lazy").lazyload();
              if (jQuery(data).find(".load_more a").length) {
                jQuery(".load_more a")
                  .last()
                  .attr(
                    "href",
                    jQuery(data).find(".load_more a").last().attr("href")
                  );
                jQuery(".load_more").show();
                thisCT.flagScroll = true;
                // update offset page
                var current_page = parseInt(
                  jQuery(data).find(".load_more a").last().data("page")
                );
                if (current_page > 0) {
                  var page_size = parseInt(
                    $(".page-num-offset").data("page_size")
                  );
                  var total_display = parseInt(
                    $(".page-num-offset").data("total_result")
                  );
                  var total_displayed = current_page * page_size;
                  if (total_display > total_displayed) {
                    $(".result-offset")
                      .html(total_displayed)
                      .css("padding-right", "5px");
                  }
                } else {
                  $(".page-num-offset").html(
                    $(".page-num-offset").data("total_result")
                  );
                }
              } else {
                thisCT.pInfScrMore = false;
                jQuery(".load_more").remove();
                $(".page-num-offset").html(
                  $(".page-num-offset").data("total_result")
                );
              }
            },
            dataType: "html"
          });
        }
      },
      onUnload: function(evt) {
        this.$container.off(this.BlogNamspace);
      }
    }
  );
  return BlogTemplate;
})();
theme.portfolioMasonry = (function() {
  function portfolioMasonry(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.portfolioId = $("#shopify-section-" + sectionId);
    this.portfolio = $("#unero-site-content");
    this.portfolioNamspace = "#unero-site-content";
    this._init();
  }

  portfolioMasonry.prototype = _.assignIn({}, portfolioMasonry.prototype, {
    _init: function() {},
    onUnload: function(evt) {
      this.$container.off(this.portfolioNamspace);
    }
  });
  return portfolioMasonry;
})();
theme.portfolioCarousel = (function() {
  function portfolioCarousel(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.portfolioId = $("#shopify-section-" + sectionId);
    this.portfolio = $("#unero-site-content");
    this.portfolioNamspace = "#unero-site-content";
    this._init();
  }

  portfolioCarousel.prototype = _.assignIn({}, portfolioCarousel.prototype, {
    _init: function() {},
    onUnload: function(evt) {
      this.$container.off(this.portfolioNamspace);
    }
  });
  return portfolioCarousel;
})();
theme.ArticleTemplate = (function() {
  function ArticleTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.articleId = $("#shopify-section-" + sectionId);
    this.article = $(".article-" + sectionId);
    this.articleNamspace = ".article-" + sectionId;
    this._init();
  }

  ArticleTemplate.prototype = _.assignIn({}, ArticleTemplate.prototype, {
    _init: function() {
    	this._initRecommended();
    },
    _initRecommended: function() {
      var self = $(this.articleNamspace + " .related.products ul.products");
      self.length > 0 && self.data("slide_enable") == "1" &&
        self.not(".slick-initialized").slick({
        slidesToShow: self.data("per_view"),
        slidesToScroll: self.data("per_view"),
        arrows: false,
        lazyLoad: "ondemand",
        dots: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.articleNamspace);
    }
  });
  return ArticleTemplate;
})();

theme.faqsTemplate = (function() {
  function faqsTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.faqsId = $("#shopify-section-" + sectionId);
    this.faqs = $("#content");
    this.faqsNamspace = "#content";
    this._init();
  }

  faqsTemplate.prototype = _.assignIn({}, faqsTemplate.prototype, {
    _init: function() {},
    onUnload: function(evt) {
      this.$container.off(this.faqsNamspace);
    }
  });
  return faqsTemplate;
})();

theme.aboutTemplate = (function() {
  function aboutTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.aboutId = $("#shopify-section-" + sectionId);
    this.about = $("#content");
    this.aboutNamspace = "#content";
    this.aboutSlide = $("#slide-"+ sectionId);
    this._init();
  }

  aboutTemplate.prototype = _.assignIn({}, aboutTemplate.prototype, {
    _init: function() {
    	this._initSlide();
    },
    _initSlide: function() {
      var sSlide = this.aboutSlide;
      sSlide.not('.slick-initialized').slick({
        slidesToShow  : parseInt(sSlide.data('per_view')),
        slidesToScroll: 1,
        lazyLoad      : 'ondemand',
        dots: false,
        arrows : false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.aboutNamspace);
    }
  });
  return aboutTemplate;
})();
theme.SliderSection = (function() {
  function SliderSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.sliderId = $("#shopify-section-" + sectionId);
    this.slider = $("#" +sectionId);
    this.sliderNamspace = "#"+sectionId;
    this._init();
  }

  SliderSection.prototype = _.assignIn({}, SliderSection.prototype, {
    _init: function() {
      if(this.slider.data('parallax') == "1"){
        if($(document.body).hasClass('header-slider-top')) {
          $(document.body).removeClass('header-slider-noparallax');
        }
        $(document.body).removeClass("page-header-layout-1").addClass("page-header-layout-3");
        pageHeader();
      }else{
        if($(document.body).hasClass('header-slider-top')) {
          $(document.body).addClass('header-slider-noparallax');
        }
      	$(document.body).addClass("page-header-layout-1");
      }
      function pageHeader() {

        if (!$('.page-header').hasClass('page-header-sliders')) {
          $('.page-header.parallax').parallax('50%', 0.6);
          return;
        }

        var $pageHeader = $('.page-header-sliders'),
            speed = $pageHeader.data('speed'),
            fade = false,
            autoplay = $pageHeader.data('auto'),
            parallax = $pageHeader.data('parallax');
        if (parallax== "1") {
          fade = true;
        }
        $pageHeader.find('ul').not('.slick-initialized').slick({
          slidesToShow  : 1,
          slidesToScroll: 1,
          infinite      : true,
          autoplaySpeed : speed,
          autoplay      : autoplay,
          fade          : fade,
          cssEase       : 'linear',
          prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
          nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>'
        });

        if (parallax == '0') {
          $('.page-header-sliders.parallax').find('li').parallax('50%', 0.6);

        } else {
          var hPageHeader = $pageHeader.height();
          if ($(document.body).hasClass('admin-bar')) {
            hPageHeader = hPageHeader - 32;
          }

          $('#content').css('margin-top', hPageHeader);

          $pageHeader.addClass('parallax-2');

          $(window).on('scroll', function () {
            var wScrollTop = $(window).scrollTop();
            if (wScrollTop > 0) {
              $('.page-header-sliders.parallax-2').css({opacity: (hPageHeader - wScrollTop) / hPageHeader});
            } else {
              $('.page-header-sliders.parallax-2').css({opacity: 1});
            }
          });
        }

      };
      this._initSlider();
    },
    _initSlider: function() {
      if (!this.slider.hasClass('page-header-sliders')) {
        $('.page-header.parallax').parallax('50%', 0.6);
        return;
      }

      var $pageHeader = this.slider,
          speed = $pageHeader.data('speed'),
          fade = false,
          autoplay = $pageHeader.data('auto'),
          parallax = $pageHeader.data('parallax');
      if (parallax== "1") {
        fade = true;
      }
      $pageHeader.find('ul').not('.slick-initialized').slick({
        slidesToShow  : 1,
        slidesToScroll: 1,
        infinite      : true,
        autoplaySpeed : speed,
        autoplay      : autoplay,
        fade          : fade,
        cssEase       : 'linear',
        prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
        nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>'
      });

      if (parallax == '') {
        $('.page-header-sliders.parallax').find('li').parallax('50%', 0.6);

      } else {
        var hPageHeader = $pageHeader.height();
        if ($(document.body).hasClass('admin-bar')) {
          hPageHeader = hPageHeader - 32;
        }

        $('#content').css('margin-top', hPageHeader);

        $pageHeader.addClass('parallax-2');

        $(window).on('scroll', function () {
          var wScrollTop = $(window).scrollTop();
          if (wScrollTop > 0) {
            $('.page-header-sliders.parallax-2').css({opacity: (hPageHeader - wScrollTop) / hPageHeader});
          } else {
            $('.page-header-sliders.parallax-2').css({opacity: 1});
          }
        });
      }
    },
    onUnload: function(evt) {
      this.$container.off(this.sliderNamspace);
    }
  });
  return SliderSection;
})();

theme.uneroSliderSection = (function() {
  function uneroSliderSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroSliderId = $("#unero-sliders-wrapper-" + sectionId);
    this.uneroSlider = $("#unero-sliders-" + sectionId);
    this.uneroSliderNamspace = "#unero-sliders-" + sectionId;
    this._init();
  }

  uneroSliderSection.prototype = _.assignIn({}, uneroSliderSection.prototype, {
    _init: function() {
    	this._initUneroSlide();
    },
    _initUneroSlide: function(){
      var infinite = false,
          fade = false,
          direction = false,
          height = parseInt(this.uneroSliderId.data("height")),
          parallax = parseInt(this.uneroSliderId.data("parallax")),
          speed = this.uneroSliderId.data("speed"),
          autoplay = this.uneroSliderId.data("autoplay"),
          dots = (this.uneroSliderId.data("dots")== "1" ? true : false),
          $carouselID = this.uneroSlider;
        if (this.uneroSliderId.data("autoplay") == '1') {
          infinite = true;
        }

        if (parallax== "1") {
          fade = true;
        }
      	
      	if (this.uneroSliderId.data("direction") == "1") {
          direction = true;
        }
        $carouselID.not('.slick-initialized').slick({
          rtl: direction,
          slidesToShow  : 1,
          slidesToScroll: 1,
          autoplaySpeed : speed,
          dots : dots,
          autoplay      : autoplay,
          infinite      : infinite,
          fade          : fade,
          lazyLoad      : 'ondemand',
          prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
          nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>'
        });

        $(window).on('resize', function () {

          if (height > 0) {
            var wWidth = $(window).width(),
                wSlider = (wWidth * height) / 1903;

            $carouselID.height(wSlider);
          }

        }).trigger('resize');

        if (parallax == '1') {
          $carouselID.find('.featured-img').parallax('50%', 0.6);
        }

        $carouselID.imagesLoaded(function () {
          $carouselID.addClass('loaded');
        });

        var video = $carouselID.find('.unvideo-bg').find('video');
        if (video.length > 0) {
          video[0].play();
        }

        $carouselID.on('afterChange', function (event, slick, currentSlide) {
          var video = $carouselID.find('.slick-slide[data-slick-index="' + currentSlide + '"]').find('video');
          if (video.length > 0) {
            video[0].play();
          }
        });

        $carouselID.on('beforeChange', function (event, slick, currentSlide) {
          var video = $carouselID.find('.slick-slide[data-slick-index="' + currentSlide + '"]').find('video');
          if (video.length > 0) {
            video[0].pause();
          }
        });
    },
    onUnload: function(evt) {
      this.$container.off(this.uneroSliderNamspace);
    }
  });
  return uneroSliderSection;
})();

theme.uneroHeroSliderSection = (function() {
  function uneroHeroSliderSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroHeroSliderId = $("#shopify-section-" + sectionId);
    this.uneroHeroSlider = $("#unero-hero-slider-" + sectionId);
    this.uneroHeroSliderNamspace = "#unero-hero-slider-" + sectionId;
    this._init();
  }

  uneroHeroSliderSection.prototype = _.assignIn({}, uneroHeroSliderSection.prototype, {
    _init: function() {
    	this._initUneroHeroSlide();
    },
    _initUneroHeroSlide: function(){
      $('.unero-hero-slider').on('mouseover touchstart', '.item-content', function () {
        var $tab = $(this),
            index = $tab.index(),
            $images = $tab.closest('.unero-hero-slider').find('.item-image');

        $images.removeClass('active');
        $tab.siblings().removeClass('active');

        $tab.addClass('active');
        $images.filter(':eq(' + index + ')').addClass('active');

      });
    },
    onUnload: function(evt) {
      this.$container.off(this.uneroHeroSliderNamspace);
    }
  });
  return uneroHeroSliderSection;
})();

theme.uneroCollectionsSection = (function() {
  function uneroCollectionsSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroCollectionsId = $("#unero-banners-carousel-" + sectionId);
    this.uneroCollections = $("#banners-carousel-" + sectionId);
    this.uneroCollectionsNamspace = "#banners-carousel-" + sectionId;
    this._init();
  }

  uneroCollectionsSection.prototype = _.assignIn({}, uneroCollectionsSection.prototype, {
    _init: function() {
    	this.uneroCollectionsId.data('slide_enable') == "1" && this._initUneroCollections();
    },
    _initUneroCollections: function(){
      var infinite = false,
          direction =false,
          speed = this.uneroCollectionsId.data("speed"),
          autoplay = this.uneroCollectionsId.data("autoplay"),
          perview = this.uneroCollectionsId.data("perview"),
          $carouselID = this.uneroCollections;
      if (this.uneroCollectionsId.data("autoplay") == '1') {
        infinite = true;
      }

      if (this.uneroCollectionsId.data("direction") == "1") {
        direction = true;
      }
      $carouselID.not('.slick-initialized').slick({
        rtl: direction,
        slidesToShow  : perview,
        slidesToScroll: 1,
        autoplaySpeed : speed,
        autoplay      : autoplay,
        infinite      : infinite,
        lazyLoad      : 'ondemand',
        prevArrow     : '<span class="icon-arrow-left slick-prev-arrow"></span>',
        nextArrow     : '<span class="icon-arrow-right slick-next-arrow"></span>',
        responsive    : [
          {
            breakpoint: 1200,
            settings  : {
              slidesToShow  : 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings  : {
              slidesToShow  : 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      $carouselID.imagesLoaded(function () {
        $carouselID.addClass('loaded');
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.uneroCollectionsNamspace);
    }
  });
  return uneroCollectionsSection;
})();

theme.uneroCollectionsMasonrySection = (function() {
  function uneroCollectionsMasonrySection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroCollectionsId = $("#shopify-section-" + sectionId);
    this.uneroCollections = $("#unero-collections-masonry-wrapper-" + sectionId);
    this.uneroCollectionsNamspace = "#unero-collections-masonry-wrapper-"+ sectionId;
    this.uneroBanner = $(".unero-banner-"+ sectionId );
    this.uneroNewsletter = $("#mc-form.newsletter-"+ sectionId );
    this._init();
  }

  uneroCollectionsMasonrySection.prototype = _.assignIn({}, uneroCollectionsMasonrySection.prototype, {
    _init: function() {
      this.uneroBanner.length > 0 && this.uneroBanner.each(function () {
        var fwidth = $(this).find('.text').width(),
            fleft = (( fwidth / 2 + 25 ) ) * -1,
            fheight = $(this).find('.data-height').data('height');

        if ($(this).hasClass('text-align-left')) {
          $(this).find('.text').css('left', fleft);
        } else {
          $(this).find('.text').css('right', fleft);
        }

        if ($(this).hasClass('text-position-center')) {
          $(this).find('.text').css('top', (fheight - fwidth) / 2);
        }

      });
      this.uneroNewsletter.length > 0 && this._initNewsletter();
    },
    _initNewsletter: function() {
      var n = this.uneroNewsletter,
          r = n.attr("action");
      n.ajaxChimp({
        url: r,
        callback: function(e) {
          e.result === "success" && responseNewsletter();
        }
      })
      function responseNewsletter(){
      }
    },
    onUnload: function(evt) {
      this.$container.off(this.uneroCollectionsNamspace);
    }
  });
  return uneroCollectionsMasonrySection;
})();
theme.uneroBannerSection = (function() {
  function uneroBannerSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroBannerId = $("#shopify-section-" + sectionId);
    this.uneroBanner = $("#unero-banners-grid-" + sectionId);
    this.uneroBannerNamspace = "#unero-banners-grid-"+ sectionId;
    this._init();
  }

  uneroBannerSection.prototype = _.assignIn({}, uneroBannerSection.prototype, {
    _init: function() {},
    onUnload: function(evt) {
      this.$container.off(this.uneroBannerNamspace);
    }
  });
  return uneroBannerSection;
})();

theme.uneroBannerMetroSection = (function() {
  function uneroBannerMetroSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroBannerId = $("#shopify-section-" + sectionId);
    this.uneroBanner = $("#unero-banners-metro-" + sectionId);
    this.uneroBannerNamspace = "#unero-banners-metro-"+ sectionId;
    this._init();
  }

  uneroBannerMetroSection.prototype = _.assignIn({}, uneroBannerMetroSection.prototype, {
    _init: function() {
      this._initMasonry();
    },
    _initMasonry: function() {
      var bannerMetro = this.uneroBanner;
      bannerMetro.find(".unero-banners-metro-content").imagesLoaded(function() {
        
        bannerMetro.find(".unero-banners-metro-content").isotope({
          itemSelector: ".banner-item",
          layoutMode: "packery"
        });
        
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.uneroBannerNamspace);
    }
  });
  return uneroBannerMetroSection;
})();

theme.uneroAboutSection = (function() {
  function uneroAboutSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroAboutId = $("#shopify-section-" + sectionId);
    this.uneroAbout = $("#unero-about-wrapper-" + sectionId);
    this.uneroAboutNamspace = "#unero-about-wrapper-"+ sectionId;
    this._init();
  }

  uneroAboutSection.prototype = _.assignIn({}, uneroAboutSection.prototype, {
    _init: function() {},
    onUnload: function(evt) {
      this.$container.off(this.uneroAboutNamspace);
    }
  });
  return uneroAboutSection;
})();
theme.uneroProductsCarouselSection = (function() {
  function uneroProductsCarouselSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.carouselId = $("#unero-products-carousel-wrapper-" + sectionId);
    this.carousel = $(".unero-products-carousel-" + sectionId);
    this.carouselNamspace = "#unero-products-carousel-"+ sectionId;
    this._init();
  }

  uneroProductsCarouselSection.prototype = _.assignIn({}, uneroProductsCarouselSection.prototype, {
    _init: function() {
      this.carousel.length > 0 && this.carousel.each(function() {
        if($(this).data('slide') == "1") {
          var self = $(this),
              perview = $(this).data('perview'),
              autoplay = $(this).data('autoplay'),
              speed = $(this).data('speed');
          var infinite = false;
          if (autoplay == '1') {
            infinite = true;
          }
          self.not('.slick-initialized').slick({
            rtl: false,
            slidesToShow  : perview,
            slidesToScroll: 1,
            autoplaySpeed : speed,
            autoplay      : autoplay,
            infinite      : infinite,
            lazyLoad      : 'ondemand',
            prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>',
            responsive    : [
              {
                breakpoint: 1200,
                settings  : {
                  slidesToShow  : 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings  : {
                  slidesToShow  : 2,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.carouselNamspace);
    }
  });
  return uneroProductsCarouselSection;
})();

theme.uneroInstagramSection = (function() {
  function uneroInstagramSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroInstagramId = $("#unero-instagram-wrapper-" + sectionId);
    this.uneroInstagram = $("#unero-instagram-" + sectionId);
    this.uneroInstagramNamspace = "#unero-instagram-" + sectionId;
    this.uneroInstagramTarget = "unero-instagram-" + sectionId;
    this._init();
  }

  uneroInstagramSection.prototype = _.assignIn({}, uneroInstagramSection.prototype, {
    _init: function() {
      (this.uneroInstagram.data('type')  == "carousel") ? this._initCarousel() : this._initGrid();
    },
    _initGrid: function() {
      var self = this.uneroInstagram,
          selfNamespace = this.uneroInstagramTarget,
          user_id = self.attr("data-id"),
          access_token = self.attr("data-token"),
          limit = self.attr("data-limit");
      var feed = new Instafeed({
        get: "user",
        target: selfNamespace,
        accessToken: access_token,
        userId: parseInt(user_id),
        limit: parseInt(limit),
        resolution: "standard_resolution",
        resolution2: "standard_resolution",
        template: '<div class="wrap animated"><a class="fauximg-bin" target="_blank" href="{{link}}"><figure class="snpt__fauximg" style="background-image: url({{image}})"></figure><i class="t-icon icon-bag2 snptlinked-item-ico"></i></a><div class="snptcrd__ovrly"><div class="ovrly_content snpt-atm sfx-scale-up"><div class="snpt-atm-el sfx__animated"><div class="snptcrd__button"><i class="t-icon icon-bag2"></i></div></div></div></div></div>'
      });
      feed.run();
    },
    _initCarousel: function() {
      var self = this.uneroInstagram,
          selfNamespace = this.uneroInstagramTarget,
          user_id = self.attr("data-id"),
          access_token = self.attr("data-token"),
          limit = self.attr("data-limit"),
          columns = self.data("perview"),
          autoplay = self.data("autoplay"),
          infinite = false,
          speed = self.data("speed");

      var feed = new Instafeed({
        get: "user",
        target: selfNamespace,
        accessToken: access_token,
        userId: parseInt(user_id),
        limit: parseInt(limit),
        resolution: "standard_resolution",
        resolution2: "standard_resolution",
        template: '<li class="product"><a class="insta-item" target="_blank" href="{{link}}" style="background-image:url({{image}});"><i class="social_instagram"></i></a></li>',
		after: function() {
          if (autoplay > 0) {
            infinite = true;
            autoplay = true;
          } else {
            autoplay = false;
          }

          self.not(".slick-initialized").slick({
            slidesToShow: columns,
            slidesToScroll: 1,
            autoplaySpeed: speed,
            autoplay: autoplay,
            infinite: infinite,
            dots: false,
            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      });
      feed.run();
    },
    onUnload: function(evt) {
      this.$container.off(this.uneroInstagramNamspace);
    }
  });
  return uneroInstagramSection;
})();

theme.unseroBlogSection = (function() {
  function unseroBlogSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.unseroBlogId = $("#shopify-section-" + sectionId);
    this.unseroBlog = $("#unero-posts-"+sectionId);
    this.unseroBlogNamspace = "#unero-posts-"+sectionId;
    this._init();
  }

  unseroBlogSection.prototype = _.assignIn({}, unseroBlogSection.prototype, {
    _init: function() {},
    onUnload: function(evt) {
      this.$container.off(this.unseroBlogNamspace);
    }
  });
  return unseroBlogSection;
})();

theme.toTopSection = (function() {
  function toTopSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.toTopId = $("#shopify-section-"+sectionId) ;
    this.toTop = $("#to-top-"+sectionId);
    this.toTopNamespace = "#to-top-"+sectionId;
    this._init();
  }

  toTopSection.prototype = _.assignIn({}, toTopSection.prototype, {
    _init: function() {
      this._initToTop();
    },
    _initToTop: function() {
      // browser window scroll (in pixels) after which the "back to top" link is shown
      var offset = 300,
          //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
          offset_opacity = 1200,
          //duration of the top scrolling animation (in ms)
          scroll_top_duration = 700,
          //grab the "back to top" link
          $back_to_top = $('.cd-top');

      //hide or show the "back to top" link
      $(window).scroll(function(){
        ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
        if( $(this).scrollTop() > offset_opacity ) { 
          $back_to_top.addClass('cd-fade-out');
        }
      });

      //smooth scroll to top
      $back_to_top.on('click', function(event){
        event.preventDefault();
        $('body,html').animate({
          scrollTop: 0 ,
        }, scroll_top_duration
                              );
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.toTopNamespace);
    }
  });
  return toTopSection;
})();
theme.unseroNewsletterSection = (function() {
  function unseroNewsletterSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.unseroNewsletterId = $("#shopify-section-" + sectionId);
    this.unseroNewsletter = $("#unero-newsletter-"+sectionId);
    this.unseroNewsletterNamspace = "#unero-newsletter-"+sectionId;
    this.uneroNewsletterForm = $("#mc-form.newsletter-"+sectionId);
    this._init();
  }

  unseroNewsletterSection.prototype = _.assignIn({}, unseroNewsletterSection.prototype, {
    _init: function() {
      var n = this.uneroNewsletterForm,
          r = n.attr("action");
      n.ajaxChimp({
        url: r,
        callback: function(e) {
          e.result === "success" && responseNewsletter();
        }
      })
      function responseNewsletter(){
      }
    },
    onUnload: function(evt) {
      this.$container.off(this.unseroNewsletterNamspace);
    }
  });
  return unseroNewsletterSection;
})();

theme.uneroProductTabsSection = (function() {
  function uneroProductTabsSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.productTabsId = $("#product-tabs-wrapper-" + sectionId);
    this.productTabs = $("#product-tabs-wrapper-" + sectionId);
    this.productTabsNamspace = "#product-tabs-wrapper-" + sectionId;
    this.productTabsShop = $("#product-tabs-wrapper-" + sectionId + " .product-tabs-masonry-2");
    this.productTabsBlog = $("#product-tabs-wrapper-" + sectionId + " .product-tabs-masonry-3");
    this._init();
  }

  uneroProductTabsSection.prototype = _.assignIn({}, uneroProductTabsSection.prototype, {
    _init: function() {
      this._initTab();
      this.productTabsShop.length > 0 && this._initShopLayout();
      this.productTabs.data('animation')== "1" && this._animationProduct();
    },
    _initTab: function() {
      $(this.productTabsNamspace + " .product-tabs")
        .off("click")
        .on("click", "ul.tabs li a", function(event) {
          event.preventDefault();
			
          if ($(this).parent("li").hasClass("active")) {
            return false;
          } else {
            var $tab = $(this);
            var $tabs_wrapper = $tab.closest(".product-tabs");
            var $tabs = $tabs_wrapper.find("ul.tabs");
			var content = $($tab.attr("href")).find("ul.products")
            $tabs.find("li").removeClass("active");
            $(this).parent("li").addClass("active");

            $tabs_wrapper.find(".panel:visible").fadeOut(300, function() {
              $tabs_wrapper.find($tab.attr("href")).fadeIn(300, function() {

                $($tab.attr("href")).hasClass("product-tabs-masonry-2") && new Isotope('.product-tabs-masonry-2 .products');
              });
              
            });
            return false;
          }
        });
    },
    _initShopLayout: function() {
      var productTabsShop = this.productTabsShop;
      $(document.body).imagesLoaded(function() {
        productTabsShop.each(function(){
          $(this).find("ul.products").isotope({
            itemSelector: "li.product",
            layoutMode: "masonry"
          });
        })
      });
    },
    _animationProduct: function() {
      var $elements = $(document.body).find(".un-shop-content .product-inner");

      $elements.removeAttr("data-sr-id").removeAttr("style");

      var config = {
        viewFactor: 0.15,
        duration: 1000,
        scale: 0.9,
        opacity: 1,
        easing: "ease"
      };
      window.sr = new ScrollReveal(config);

      var block = {
        reset: true,
        viewOffset: { top: 64 }
      };

      sr.reveal($elements, block);
    },
    onUnload: function(evt) {
      this.$container.off(this.productTabsNamspace);
    }
  });
  return uneroProductTabsSection;
})();

theme.unseroStaticBlockSection = (function() {
  function unseroStaticBlockSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.unseroStaticBlockId = $("#shopify-section-" + sectionId);
    this.unseroStaticBlock = $("#static-block-"+ sectionId);
    this.unseroStaticBlockNamspace = "#static-block-"+ sectionId;
    this._init();
  }

  unseroStaticBlockSection.prototype = _.assignIn({}, unseroStaticBlockSection.prototype, {
    _init: function() {
      if(this.unseroStaticBlockId.prev().length == 0){
        this.unseroStaticBlock.data("mix_header") == "1" ? $(document.body).addClass("mix-header") :$(document.body).removeClass("mix-header");
      }
    },
    onUnload: function(evt) {
      this.$container.off(this.unseroStaticBlockNamspace);
    }
  });
  return unseroStaticBlockSection;
})();

theme.uneroTestimonial = (function() {
  function uneroTestimonial(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.uneroTestimonialId = $("#shopify-section-" + sectionId);
    this.uneroTestimonial = $("#testimonial-"+ sectionId);
    this.uneroTestimonialNamspace = "#testimonial-"+ sectionId;
    this._init();
  }

  uneroTestimonial.prototype = _.assignIn({}, uneroTestimonial.prototype, {
    _init: function() {
      this.uneroTestimonial.not('.slick-initialized').slick({
        rtl: false,
        slidesToShow  : 1,
        slidesToScroll: 1,
        autoplaySpeed : 5000,
        autoplay      : true,
        infinite      : true,
        lazyLoad      : 'ondemand',
        prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
        nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>',
        responsive    : []
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.uneroTestimonialNamspace);
    }
  });
  return uneroTestimonial;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.YouTubeVideos.loadVideos();
}

theme.YouTubeVideos = (function() {
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
     	modestbranding: 1,
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        branding: 0,
        rel: 0,
        autohide: 1,
      	cc_load_policy: 1,
      	disablekb:0,
      	fs: 1,
      	iv_load_policy: 3,
      	start: 0,
      	end: 0,
        loop: 1,
      	rel:0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.id) {
      return;
    }

    videos[$video.id] = {
      id: $video.id,
      playerId: $video.player_id, 
      videoId: $video.video_id,
      homeVideo: $video.home_video,
      videoSelector: $video.id,
      playerVars: $video.playerDefaults
    };
	
    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }


  function loadVideos() {
    var player;
    var homeVideo;
    var homeVideoWidth;
    var playerWidth;
    var playerHeight;
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        //console.log( videos[key]);
        // args.playerVars.controls = args.controls;
        args.playerId.addClass('home_video_bg');
        //console.log(args)	;
        // init Player 
        videoPlayers[key] = new YT.Player(key, args);
      }
    }
	sizeBackgroundVideos();
    initEvents();
    youtubeLoaded = true;
  } 
  function onPlayerReady(evt) {
    var videoData = getVideoOptions(evt);
    videoData.playerId.addClass('home_video_bg');
    evt.target.setPlaybackQuality('hd1080');
    evt.target.mute();
    evt.target.setLoop(true);
    sizeBackgroundVideos();
  }
  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended        
      //  console.log('ended');
        videoPlayers[videoData.id].seekTo(videoData.playerVars.start);
        break;
      case 1: // playing
        //setAsPlaying(videoData);
        break;
      case 2: // paused
        //setAsPaused(videoData);
     //   console.log('paused');
        break;
    }
  }
  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }
  function sizeBackgroundVideos() {
  	$('.home_video_bg').each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }
  function sizeBackgroundVideo($player) {
    
    var $slide = $player.closest('.home-video');    
    var player = $player;
    var slideWidth = $slide.width();
    var slideHeight = $slide.height();
    var playerWidth = player.width();
    var playerHeight = player.height();
    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }
	//console.log(playerWidth);
   // console.log(playerHeight);
    $slide.height(playerHeight);
    $player.addClass('home_video_loaded');
  }
  function resizeBackgroundVideos($player) {
  	var $slide = $player.closest('.home-video');    
    var player = $player;
     var w = $(window).width()+200,
      h = $(window).height()+200;

    if (w/h > 16/9){
      player.setSize(w, w/16*9);
      player.css({'left': '0px'});
    } else {
      player.setSize(h/9*16, h);
      player.css({'left': -player.outerWidth()-w/2});
    }   
  }
  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    videoPlayers[key] = new YT.Player(key, args);
   // videoPlayers[key].mute();
   // videoPlayers[key].setLoop(true);
    initEvents();
  }
  function initEvents() {
  	 // Listen to resize to keep a background-size:cover-like layout
      $(window).on('resize.videoPlayer', $.debounce(250, function() {
        if (youtubeLoaded) {
         // console.log('resize');
      //    resizeBackgroundVideos();
        }
      }));
  }
 
  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo
  };
})();

theme.uneroVideos = (function() {
   
  function uneroVideos(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    
    this.videoId = $("#shopify-section-"+sectionId) ;
    this.videoNamspace = "#home-video-"+sectionId;
    this.VideoHomeId = $(this.videoNamspace);
    this.PlayerNamespace = "playerYoutube-"+sectionId ;
    this.PlayerId = $("#playerYoutube-"+sectionId);
    this.VideoHomeWidth = $(this.videoNamspace + " .video_width");
    this.options = {
      video_type: this.VideoHomeId.data('video_type')
    };
    this.video_start = this.VideoHomeId.data('video_start');
    var duration = this.VideoHomeId.data('video_duration');
    this.video_end = parseInt(this.video_start ) + parseInt(duration);
     
    if(this.options.video_type == 'yt-video') {
    	this._handleYoutubeVideo();
    }
  }

  uneroVideos.prototype = _.assignIn({}, uneroVideos.prototype, {
    
    _handleYoutubeVideo: function() {
      var video_params = {
        id: this.PlayerNamespace,
        video_id: this.PlayerId.data('video_id'),
        home_video: this.VideoHomeId,
        player_id: this.PlayerId,
        playerDefaults:{
          modestbranding: 1,
          autoplay: 1,
          controls: 0,
          showinfo: 0,
          branding: 0,
          rel: 0,
          autohide: 1,
          start: this.video_start,
          end: this.video_end
        }
      };
     
      window.home_video_list[video_params.id] = video_params;
      theme.YouTubeVideos.init(video_params);
      theme.YouTubeVideos.loadVideo(video_params.id);
    },
    onUnload: function(evt) {
	  this.$container.off(this.videoNamspace);
    },
    onSelect: function(evt) {
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });
  return uneroVideos;
})();

theme.uneroBrands = (function() {
  function uneroBrands(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.brandsId = $("#brands-" + sectionId);
    this.brands = $(".brands-" + sectionId);
    this.featuredBrands = $(".featured-brands-" + sectionId);
    this.brandsNamspace = "#brands-"+ sectionId;
    this._init();
  }

  uneroBrands.prototype = _.assignIn({}, uneroBrands.prototype, {
    _init: function() {
      var perview = this.featuredBrands.data('perview'),
          autoplay = this.featuredBrands.data('autoplay'),
          speed = this.featuredBrands.data('speed');
      var infinite = false;
      if (autoplay == '1') {
        infinite = true;
      }
      this.featuredBrands.not('.slick-initialized').slick({
        rtl: false,
        slidesToShow  : perview,
        slidesToScroll: 1,
        autoplaySpeed : speed,
        autoplay      : autoplay,
        infinite      : true,
        lazyLoad      : 'ondemand',
        prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
        nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>',
        responsive    : [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.brandsNamspace);
    }
  });
  return uneroBrands;
})();
theme.gridsSection = (function() {
  function gridsSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.gridsId = $("#grid-wrapper-" + sectionId);
    this.grids = $("#grid-wrapper-" + sectionId);
    this.gridsNamspace = "#grid-wrapper-"+ sectionId;
    this._init();
  }

  gridsSection.prototype = _.assignIn({}, gridsSection.prototype, {
    _init: function() {
      var sectionId = this.sectionId ;
      var Grid = (function() {

        // list of items
        var $grid = $( '#og-grid-' +sectionId),
            // the items
            $items = $grid.children( 'li' ),
            // current expanded item's index
            current = -1,
            // position (top) of the expanded item
            // used to know if the preview will expand in a different row
            previewPos = -1,
            // extra amount of pixels to scroll the window
            scrollExtra = 0,
            // extra margin when expanded (between preview overlay and the next items)
            marginExpanded = 10,
            $window = $( window ), winsize,
            $body = $( 'html, body' ),
            // transitionend events
            transEndEventNames = {
              'WebkitTransition' : 'webkitTransitionEnd',
              'MozTransition' : 'transitionend',
              'OTransition' : 'oTransitionEnd',
              'msTransition' : 'MSTransitionEnd',
              'transition' : 'transitionend'
            },
            transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ],
            // support for csstransitions
            support = Modernizr.csstransitions,
            // default settings
            settings = {
              minHeight : 500,
              speed : 350,
              easing : 'ease'
            };

        function init( config ) {

          // the settings..
          settings = $.extend( true, {}, settings, config );

          // preload all images
          $grid.imagesLoaded( function() {

            // save item´s size and offset
            saveItemInfo( true );
            // get window´s size
            getWinSize();
            // initialize some events
            initEvents();

          } );

        }

        // add more items to the grid.
        // the new items need to appended to the grid.
        // after that call Grid.addItems(theItems);
        function addItems( $newitems ) {

          $items = $items.add( $newitems );

          $newitems.each( function() {
            var $item = $( this );
            $item.data( {
              offsetTop : $item.offset().top,
              height : $item.height()
            } );
          } );

          initItemsEvents( $newitems );

        }

        // saves the item´s offset top and height (if saveheight is true)
        function saveItemInfo( saveheight ) {
          $items.each( function() {
            var $item = $( this );
            $item.data( 'offsetTop', $item.offset().top );
            if( saveheight ) {
              $item.data( 'height', $item.height() );
            }
          } );
        }

        function initEvents() {

          // when clicking an item, show the preview with the item´s info and large image.
          // close the item if already expanded.
          // also close if clicking on the item´s cross
          initItemsEvents( $items );

          // on window resize get the window´s size again
          // reset some values..
          $window.on( 'debouncedresize', function() {

            scrollExtra = 0;
            previewPos = -1;
            // save item´s offset
            saveItemInfo();
            getWinSize();
            var preview = $.data( this, 'preview' );
            if( typeof preview != 'undefined' ) {
              hidePreview();
            }

          } );

        }

        function initItemsEvents( $items ) {
          $items.on( 'click', 'span.og-close', function() {
            hidePreview();
            return false;
          } ).children( 'a' ).on( 'click', function(e) {

            var $item = $( this ).parent();
            // check if item already opened
            current === $item.index() ? hidePreview() : showPreview( $item );
            return false;

          } );
        }

        function getWinSize() {
          winsize = { width : $window.width(), height : $window.height() };
        }

        function showPreview( $item ) {

          var preview = $.data( this, 'preview' ),
              // item´s offset top
              position = $item.data( 'offsetTop' );

          scrollExtra = 0;

          // if a preview exists and previewPos is different (different row) from item´s top then close it
          if( typeof preview != 'undefined' ) {

            // not in the same row
            if( previewPos !== position ) {
              // if position > previewPos then we need to take te current preview´s height in consideration when scrolling the window
              if( position > previewPos ) {
                scrollExtra = preview.height;
              }
              hidePreview();
            }
            // same row
            else {
              preview.update( $item );
              return false;
            }

          }

          // update previewPos
          previewPos = position;
          // initialize new preview for the clicked item
          preview = $.data( this, 'preview', new Preview( $item ) );
          // expand preview overlay
          preview.open();

        }

        function hidePreview() {
          current = -1;
          var preview = $.data( this, 'preview' );
          preview.close();
          $.removeData( this, 'preview' );
        }

        // the preview obj / overlay
        function Preview( $item ) {
          this.$item = $item;
          this.expandedIdx = this.$item.index();
          this.create();
          this.update();
        }

        Preview.prototype = {
          create : function() {
            // create Preview structure:
            this.$title = $( '<h3></h3>' );
            this.$description = $( '<p></p>' );
            this.$href = $( '<a class="button" href="#"><span></span></a>' );
            this.$details = $( '<div class="og-details"></div>' ).append( this.$title, this.$description, this.$href );
            this.$loading = $( '<div class="og-loading"></div>' );
            this.$fullimage = $( '<div class="og-fullimg"></div>' ).append( this.$loading );
            this.$closePreview = $( '<span class="og-close"></span>' );
            this.$previewInner = $( '<div class="og-expander-inner"></div>' ).append( this.$closePreview, this.$fullimage, this.$details );
            this.$previewEl = $( '<div class="og-expander"></div>' ).append( this.$previewInner );
            // append preview element to the item
            this.$item.append( this.getEl() );
            // set the transitions for the preview and the item
            if( support ) {
              this.setTransition();
            }
          },
          update : function( $item ) {

            if( $item ) {
              this.$item = $item;
            }

            // if already expanded remove class "og-expanded" from current item and add it to new item
            if( current !== -1 ) {
              var $currentItem = $items.eq( current );
              $currentItem.removeClass( 'og-expanded' );
              this.$item.addClass( 'og-expanded' );
              // position the preview correctly
              this.positionPreview();
            }

            // update current value
            current = this.$item.index();

            // update preview´s content
            var $itemEl = this.$item.children( 'a' ),
                eldata = {
                  href : $itemEl.attr( 'href' ),
                  largesrc : $itemEl.data( 'largesrc' ),
                  title : $itemEl.data( 'title' ),
                  cta : $itemEl.data( 'cta' ),
                  description : $itemEl.data( 'description' )
                };

            this.$title.html( eldata.title );
            this.$description.html( eldata.description );
            this.$href.html("<span>"+ eldata.cta + "</span>");
            this.$href.attr( 'href', eldata.href );

            var self = this;

            // remove the current image in the preview
            if( typeof self.$largeImg != 'undefined' ) {
              self.$largeImg.remove();
            }

            // preload large image and add it to the preview
            // for smaller screens we don´t display the large image (the media query will hide the fullimage wrapper)
            if( self.$fullimage.is( ':visible' ) ) {
              this.$loading.show();
              $( '<img/>' ).load( function() {
                var $img = $( this );
                if( $img.attr( 'src' ) === self.$item.children('a').data( 'largesrc' ) ) {
                  self.$loading.hide();
                  self.$fullimage.find( 'img' ).remove();
                  self.$largeImg = $img.fadeIn( 350 );
                  self.$fullimage.append( self.$largeImg );
                }
              } ).attr( 'src', eldata.largesrc );	
            }

          },
          open : function() {

            setTimeout( $.proxy( function() {	
              // set the height for the preview and the item
              this.setHeights();
              // scroll to position the preview in the right place
              this.positionPreview();
            }, this ), 25 );

          },
          close : function() {

            var self = this,
                onEndFn = function() {
                  if( support ) {
                    $( this ).off( transEndEventName );
                  }
                  self.$item.removeClass( 'og-expanded' );
                  self.$previewEl.remove();
                };

            setTimeout( $.proxy( function() {

              if( typeof this.$largeImg !== 'undefined' ) {
                this.$largeImg.fadeOut( 'fast' );
              }
              this.$previewEl.css( 'height', 0 );
              // the current expanded item (might be different from this.$item)
              var $expandedItem = $items.eq( this.expandedIdx );
              $expandedItem.css( 'height', $expandedItem.data( 'height' ) ).on( transEndEventName, onEndFn );

              if( !support ) {
                onEndFn.call();
              }

            }, this ), 25 );

            return false;

          },
          calcHeight : function() {

            var heightPreview = winsize.height - this.$item.data( 'height' ) - marginExpanded,
                itemHeight = winsize.height;

            if( heightPreview < settings.minHeight ) {
              heightPreview = settings.minHeight;
              itemHeight = settings.minHeight + this.$item.data( 'height' ) + marginExpanded;
            }

            this.height = heightPreview;
            this.itemHeight = itemHeight;

          },
          setHeights : function() {

            var self = this,
                onEndFn = function() {
                  if( support ) {
                    self.$item.off( transEndEventName );
                  }
                  self.$item.addClass( 'og-expanded' );
                };

            this.calcHeight();
            this.$previewEl.css( 'height', this.height );
            this.$item.css( 'height', this.itemHeight ).on( transEndEventName, onEndFn );

            if( !support ) {
              onEndFn.call();
            }

          },
          positionPreview : function() {

            // scroll page
            // case 1 : preview height + item height fits in window´s height
            // case 2 : preview height + item height does not fit in window´s height and preview height is smaller than window´s height
            // case 3 : preview height + item height does not fit in window´s height and preview height is bigger than window´s height
            var position = this.$item.data( 'offsetTop' ),
                previewOffsetT = this.$previewEl.offset().top - scrollExtra,
                scrollVal = this.height + this.$item.data( 'height' ) + marginExpanded <= winsize.height ? position : this.height < winsize.height ? previewOffsetT - ( winsize.height - this.height ) : previewOffsetT;

            $body.animate( { scrollTop : scrollVal }, settings.speed );

          },
          setTransition  : function() {
            this.$previewEl.css( 'transition', 'height ' + settings.speed + 'ms ' + settings.easing );
            this.$item.css( 'transition', 'height ' + settings.speed + 'ms ' + settings.easing );
          },
          getEl : function() {
            return this.$previewEl;
          }
        }

        return { 
          init : init,
          addItems : addItems
        };

      })();
      $(function() {
        Grid.init();
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.gridsNamspace);
    }
  });
  return gridsSection;
})();
theme.CollectionCarouselTemplate = (function() {
  function CollectionCarouselTemplate(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.CollectionId = $("#collection-" + sectionId);
    this.Collection = $("#collection-" + sectionId);
    this.CollectionNamspace = "#collection-" + sectionId;
    this.carouselSlide = $(".unero-products-carousel-" + sectionId);
    this._init();
  }

  CollectionCarouselTemplate.prototype = _.assignIn({}, CollectionCarouselTemplate.prototype, {
    _init: function() {
      this.carouselSlide.length > 0 && this.carouselSlide.each(function() {
        
          var self = $(this),
              perview = $(this).data('per_view'),
              autoplay = $(this).data('autoplay'),
              speed = $(this).data('speed');
          var infinite = false;
          if (autoplay == '1') {
            infinite = true;
          }
          self.find(".unero-products-carousel-slide").not('.slick-initialized').slick({
            rtl: false,
            slidesToShow  : perview,
            slidesToScroll: 1,
            autoplaySpeed : speed,
            autoplay      : autoplay,
            infinite      : infinite,
            lazyLoad      : 'ondemand',
            prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>',
            responsive    : [
              {
                breakpoint: 1200,
                settings  : {
                  slidesToShow  : 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings  : {
                  slidesToShow  : 2,
                  slidesToScroll: 1
                }
              }
            ]
          });
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.CollectionNamspace);
    }
  });
  return CollectionCarouselTemplate;
})();
theme.ProductVariantMobile = (function() {
  function ProductVariantMobile(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var sectionType = $container.attr("data-section-type");
    this.wrapperId = $("#"+ sectionId);
    this.wrapper = $("#" + sectionId);
    this.wrapperNamspace = "#" + sectionId;
    this.addCartId = $("#btn-" + sectionId+".m-allow-cart");
    this.addCartClass = $(".variant-item-" + sectionId+".m-allow-cart");
    this._init();
  }

  ProductVariantMobile.prototype = _.assignIn({}, ProductVariantMobile.prototype, {
    _init: function() {
      var self = this;
      self._initCompact();
      self._initEvents();
      $( window ).resize(function() {
        if($( window ).width() <= 767){
           self._initCompact();
        }
      });
    },
    _initCompact: function() {
        if($(".product-variant-mobile-section").length >0){
          var $accordion = $(".product-variant-mobile-section"),
              $items = $(".product-variants-mobile");

          // Set heights on accordion items and titles on page load
          $items.each(function() {
            var $that = $(this),
                $title = $that.find(".variants-header"),
                titleHeight = $title.innerHeight(),
                contentHeight = $that.find(".variants-content").outerHeight(),
                $parent = $title.closest(".product-variants-mobile");

            $title.data("height", titleHeight);
            $that.data("height", titleHeight + contentHeight);
          });
          $items.each(function() {
            var $that = $(this),
                $title = $that.find(".variants-header"),
                titleHeight = $title.innerHeight(),
                contentHeight = $that.find(".variants-content").outerHeight(),
                $parent = $title.closest(".product-variants-mobile");

            $title.data("height", titleHeight);
            $that.data("height", titleHeight + contentHeight);

            if ($parent.hasClass("active")) {
              $parent.height($parent.data("height"));
            }
          });
          // Event for triggering accordion to show
         $accordion.unbind('click') && $accordion.on("click", ".variants-header .title", function() {
            var $that = $(this),$v_header = $that.closest(".variants-header"), $parent = $that.closest(".product-variants-mobile");

            if (!$parent.hasClass("active")) {
              $items
              .closest(".active")
              .removeClass("active")
              .height($that.data("height"));
            }
            $parent.toggleClass("active");
            // Check if the item is active and set to saved height
            // on either title or item
            if ($parent.hasClass("active")) {
              $parent.height($parent.data("height"));
            } else {
              $parent.height($v_header.data("height"));
            }
          });
        }
    },
    _initEvents: function() {
      // buy now
      var main_variant_id= $('#ProductSelect-product-template.variation-select').val();
      this.addCartId.length > 0 && (this.addCartId.unbind('click') , this.addCartId.on('click', function() {
        $('#ProductSelect-product-template.variation-select').val(main_variant_id);
        $('#AddToCart-product-template').trigger('click');
      }));
        // click on each of variants  
      this.addCartClass.length > 0 && (this.addCartClass.unbind('click') , this.addCartClass.on('click', function(){
        var variant_id = $(this).data('id');
        $('#ProductSelect-product-template.variation-select').val(variant_id);
        $('#AddToCart-product-template').trigger('click')
      }))
    },
    onUnload: function(evt) {
      this.$container.off(this.wrapperNamspace);
    }
  });
  return ProductVariantMobile;
})();
$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register("product-template", theme.Product);
  sections.register("product-template-variant", theme.Product);
  sections.register("product-variant-mobile", theme.ProductVariantMobile);
  sections.register("cart-template", theme.Cart);
  sections.register("search-template", theme.SearchTemplate);
  sections.register("blog-template", theme.BlogTemplate);
  sections.register("article-template", theme.ArticleTemplate);
  sections.register("collection-template", theme.CollectionTemplate);
  sections.register("collection-carousel-template", theme.CollectionCarouselTemplate);
  sections.register("collections-template", theme.CollectionsTemplate);
  sections.register("portfolio-masonry-template", theme.portfolioMasonry);
  sections.register(
    "collection-instagram-template",
    theme.CollectionInstagramTemplate
  );
  sections.register("faqs-template", theme.faqsTemplate);
  sections.register("contact-template", theme.Maps);
  sections.register("about-template", theme.aboutTemplate);
  sections.register("footer-section", theme.footerSection);
  sections.register("menu-sidebar-section", theme.sideBarSection);
  sections.register("mobile-nav-section", theme.mobileNavSection);
  sections.register("header-section", theme.HeaderSection);
  sections.register('totop-section', theme.toTopSection);
  // section home page
  sections.register("header-slider", theme.SliderSection);
  sections.register("unero-slider-section", theme.uneroSliderSection);
  sections.register("unero-hero-slider-section", theme.uneroHeroSliderSection);
  sections.register("unero-collections-section", theme.uneroCollectionsSection);
  sections.register("unero-collections-masonry-section", theme.uneroCollectionsMasonrySection);
  sections.register("unero-featured-collections-section", theme.uneroProductsCarouselSection);
  sections.register("unero-product-tabs-section", theme.uneroProductTabsSection);
  
  sections.register("unero-about-section", theme.uneroAboutSection);
  sections.register("unero-banner-grid-section", theme.uneroBannerSection);
  sections.register("unero-banner-metro-section", theme.uneroBannerMetroSection);
  sections.register("unero-instagram-section", theme.uneroInstagramSection);
  sections.register("unero-blog-section", theme.unseroBlogSection);
  sections.register("unero-newsletter-section", theme.unseroNewsletterSection);
  sections.register("unero-static-block", theme.unseroStaticBlockSection);
  sections.register('unero-testimonial-section', theme.uneroTestimonial);
  sections.register('unero-video-section', theme.uneroVideos);
  sections.register('unero-brand-section', theme.uneroBrands);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register("products", theme.Products);
  sections.register("blog", theme.Blog);
  sections.register("collections", theme.Collections);
  /* 1.1 */
  
  sections.register('grid-view', theme.gridsSection);
});

/* ================ APPLICATIONS ================ */

window.theme = theme || {};

theme.roarApplication = (function() {
  function initReviews() {
    "undefined" != typeof SPR &&
      (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
  }
  function updateCart() {
    $.ajax({
      url: "/search",
      beforeSend: function() {
        $("#cart-panel").addClass("loading");
      },
      success: function(result) {
        var cart_button = "#icon-cart-contents .mini-cart-counter", cart_panel = "div#cart-panel";
        $(cart_button).html($(result).find(cart_button).html());
        $(cart_panel).html($(result).filter(cart_panel).html());

        theme.show_multiple_currencies && theme.CurrencyPicker.convert("#cart-panel .money");
      },
      error: function(errorThrown) {
        console.log(errorThrown);
      }
    }).done(function() {
      $("#cart-panel").removeClass("loading");
    });
  }
  function addCartVariants() {
    $(".add_to_cart_variant_button").length > 0 &&
      $(".add_to_cart_variant_button").unbind("click"), $(
      document
    ).on("click", ".add_to_cart_variant_button", function() {
      var self = $(this);
      if (self.hasClass("disabled")) {
        alert(theme.strings.alert_variant);
      } else {
        Shopify.queue = [];
        jQuery('.qty-variant').each(function() {
          Shopify.queue.push({
            variantId: jQuery(this).data('variant_id'),
            quantity: parseInt(jQuery(this).val(), 10) || 0
          });
        });
        Shopify.moveAlong = function() {
          // If we still have requests in the queue, let's process the next one.
          //console.log(Shopify.queue);
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var ajax = $.ajax({
              type: "POST",
              url: "/cart/add.js",
              async: !0,
              cache: !1,
              data: {quantity: request.quantity, id:request.variantId},
              dataType: "json",
              beforeSend: function() {
                self.addClass("loading");
              },
              complete: function() {
                updateCart();
              },
              error: function(result) {
                var response = $.parseJSON(result.responseText),
                    message = response.message + ": " + response.description;
                alert(message);
              },
              success: function(result) {
                Shopify.moveAlong();
              }
            });
          }
          // If the queue is empty, we will redirect to the cart page.
          else {
            if (theme.cart_ajax == "") {
              window.location.href = "/cart";
            } else {
              self.removeClass("loading");
              closeModal();
              $(document.body).toggleClass("display-cart");
              openCanvasPanel($("#cart-panel"));
            }
          }
        };
        Shopify.moveAlong();
      }
      return false;
    });
  }
  function addToCart() {
    $(document).on("click", ".add_to_cart_button", function() {
      var self = $(this), form = self.closest("form");

      if (theme.cart_ajax == "") {
        form.submit();
        return false;
      }

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        cache: !1,
        data: form.serialize(),
        dataType: "json",
        beforeSend: function() {
          self.addClass("loading");
        },
        complete: function() {
          updateCart();
        },
        error: function(result) {
          var response = $.parseJSON(result.responseText),
            message = response.message + ": " + response.description;
          self.removeClass("loading");
          alert(message);
        },
        success: function(result) {}
      }).done(function() {
        self.removeClass("loading");
        closeModal();
        $(document.body).toggleClass("display-cart");
        openCanvasPanel($("#cart-panel"));
      });

      return false;
    });
  }
  function updateQuantity() {
    $(document)
      .on("focus", "#cart-panel .update", function() {
        $(this).select();
      })
      .on("blur", "#cart-panel .update", function() {
        var self = $(this);
        var quantity = self.val();
        var id = self.attr("data-id");

        var params = {
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=" + quantity + "&id=" + id,
          dataType: "json",
          beforeSend: function() {
            $("#cart-panel").addClass("loading");
          },
          success: function() {
            updateCart();
          },
          error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
          }
        };
        $.ajax(params);
      });
  }
  function removeCart() {
    $(document).on("click", "#cart-panel .remove", function(event) {
      event.preventDefault();

      var self = $(this);
      var id = self.attr("data-id");

      var params = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + id,
        dataType: "json",
        beforeSend: function() {
          self.closest("#cart-panel").addClass("loading");
        },
        success: function() {
          updateCart();
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      };
      $.ajax(params);
    });
  }
  function openModal($modal) {
    $(document.body).addClass("modal-open");
    $modal.fadeIn();
    $modal.addClass("open");
  }
  function closeModal() {
    $(document.body).removeClass("modal-open");
    $(".unero-modal").fadeOut(function() {
      $(document.body)
        .find("#menu-extra-search, #menu-extra-login")
        .removeClass("show");
      $(this).removeClass("open");
    });
  }
  function quickView() {
    $(
      document.body
    ).on("click", ".product-quick-view, .un-product-link", function(e) {
      e.preventDefault();
      var $a = $(this),
        url = $a.attr("href"),
        $modal = $("#quick-view-modal"),
        $container = $modal.find(".container"),
        $button = $modal.find(".modal-header .close-modal").first().clone(),
        sectionNamespace = $(this).data("ptnamespace");

      $a.addClass("loading");
      $container.hide().html("").addClass("invisible");
      $modal.addClass("loading");
      openModal($modal);

      $.get(
        url,
        function(response) {
          $container.html($(response));
          $modal.removeClass("loading");
          $a.removeClass("loading");
          $container.show().removeClass("invisible");
          toolTipIcon();
          initReviews();
          var sections = new theme.Sections();
          sections.register(sectionNamespace, theme.Product);
          theme.show_multiple_currencies && theme.CurrencyPicker.convert(
            "#ProductSection-" + sectionNamespace + " .money"
          );
        },
        "html"
      );
    });

    $("#quick-view-modal").on("click", function(e) {
      var target = e.target;
      if ($(target).closest("div.product").length <= 0) {
        closeModal();
      }
    });
  }
  function mapProduct() {
    addCartVariants();
    addToCart();
    removeCart();
    updateQuantity();
    quickView();
  }

  function addToWishlist() {
    $(document).on("click", ".add_to_wishlist:not(.added)", function(event) {
      if (!$(this).hasClass("need-login")) {
        event.preventDefault();

        var _self = $(this),
          _product_id = _self.data("product_id"),
          _form = _self.closest("form"),
          _data = { action: "add_wishlist" },
          _data = _form.serialize() + "&" + $.param(_data);

        $.ajax({
          type: "POST",
          url: "/a/wishlist",
          async: !0,
          cache: !1,
          data: _data,
          dataType: "json",
          beforeSend: function() {
            _self.addClass("loading"), _self
              .attr("data-original-title", _self.attr("data-loading-text"))
              .tooltip("fixTitle")
              .tooltip("show");
          },
          error: function(err) {
            console.log(err);
          },
          complete: function() {
            _self
              .attr("data-original-title", _self.attr("data-added"))
              .tooltip("fixTitle")
              .tooltip("show");
            _self.attr("data-original-title", _self.attr("data-success"));
            _self.addClass("added");
            $(".wishlist" + _product_id).addClass("added");
            $(".wishlist" + _product_id).attr(
              "data-original-title",
              _self.attr("data-success")
            );
            setTimeout(function() {
              _self.tooltip("hide");
            }, 500);
          },
          success: function(result) {
            _self.removeClass("loading");
            $(".wishlist" + _product_id + " > span").html(
              $(".wishlist" + _product_id).attr("data-success")
            );
            var _wishlist = $(".wishlist" + _self.prev().val());
            $(".menu-item-wishlist .mini-cart-counter").length > 0 && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) + 1);
            if (result["code"] == 1) {
              $(".wishlist_items_number").text(result["json"]);
              jQuery("#rtp-message").html(_self.attr("data-added"));
              jQuery("#rt-unero-popup-message")
                .css(
                  "margin-left",
                  "-" + (parseFloat(jQuery("#rt-unero-popup-message").width()) / 2)  + "px"
                )
                .fadeIn();
              window.setTimeout(function() {
                jQuery("#rt-unero-popup-message").fadeOut();
              }, 2e3);
            } else {
              alert(result["json"]);
              console.log(result["json"]);
            }
          }
        });

        return false;
      }
    });
  }

  function toTop() {
  	$('.to-top').on('click', function () {
        $('html, body').animate({scrollTop: 0}, 800);
        return false;
    });
  }
  function removeFromWishlist() {
    $(document).on("click", ".remove_from_wishlist", function(event) {
      event.preventDefault();

      var _self = $(this),
        _form = _self.closest("form"),
        _data = { action: "remove_wishlist" };
      _data = _form.serialize() + "&" + $.param(_data);

      $.ajax({
        type: "POST",
        url: "/a/wishlist",
        async: !0,
        cache: !1,
        data: _data,
        dataType: "json",
        beforeSend: function() {
          $(".page-wishlist-content").addClass("loading");
        },
        error: function(err) {
          console.log(err);
          $(".page-wishlist-content").removeClass("loading");
        },
        success: function(result) {
          if (result["code"] == 1) {
            _self.closest("tr").slideUp("fast", function() {
              _self.closest("tr").remove();
              $(".page-wishlist-content .infos").removeClass("hide");

              $(".wishlist_items_number").text(result["json"]);
              if (result["json"] == 0) {
                $(".wishlist-empty").removeClass("hide");
              }
            });
          } else {
            alert(result["json"]);
            console.log(result["json"]);
          }
          $(".page-wishlist-content").removeClass("loading");
          $(".menu-item-wishlist .mini-cart-counter").length > 0 && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) - 1);
        }
      });

      return false;
    });
  }
  function handleCompareScroll () {
  /* handle scroll */ 
    jQuery("#be_compare_features_table").on("scroll", function() {
      var parent_div = jQuery(this).parent();

      if (
        jQuery(this).scrollLeft() + jQuery(this).innerWidth() >=
        jQuery(this)[0].scrollWidth
      ) {
        if (parent_div.hasClass("scroll-right")) {
          parent_div.removeClass("scroll-right");
        }
      } else if (jQuery(this).scrollLeft() === 0) {
        if (parent_div.hasClass("scroll-left")) {
          parent_div.removeClass("scroll-left");
        }
      } else {
        if (!parent_div.hasClass("scroll-right")) {
          parent_div.addClass("scroll-right");
        }
        if (!parent_div.hasClass("scroll-left")) {
          parent_div.addClass("scroll-left");
        }
      }
    });
    be_compare_container = document.getElementById("be_compare_features_table");
    if (be_compare_container !== null) {
      if (be_compare_container.offsetWidth < be_compare_container.scrollWidth) {
        if (
          !jQuery("#be_compare_features_table_inner").hasClass("scroll-right")
        ) {
          jQuery("#be_compare_features_table_inner").addClass("scroll-right");
        }
      }
    }
    jQuery(window).on("resize", function() {
      be_compare_products_table_shadows();
    });
    if(jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right")) {
      $('.compare-preview').addClass('no-flex');
    }else{
      $('.compare-preview').removeClass('no-flex');
    }
  }
  function be_compare_products_table_shadows() {
    be_compare_container = document.getElementById("be_compare_features_table");
    if (be_compare_container === null) return;

    if (be_compare_container.offsetWidth < be_compare_container.scrollWidth) {
      if (!jQuery("#be_compare_features_table_inner").hasClass("scroll-right")) {
        jQuery("#be_compare_features_table_inner").addClass("scroll-right");
      }
    } else {
      if (jQuery("#be_compare_features_table_inner").hasClass("scroll-right")) {
        jQuery("#be_compare_features_table_inner").removeClass("scroll-right");
      }
      if (jQuery("#be_compare_features_table_inner").hasClass("scroll-left")) {
        jQuery("#be_compare_features_table_inner").removeClass("scroll-left");
      }
    }
    if(jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right")) {
    	$('.compare-preview').addClass('no-flex');
    }else{
      $('.compare-preview').removeClass('no-flex');
    }
  }
  function handleCompareEvent() {
    var body = $("body"),
        button = $("a.add_to_compare"),
        holder = '', 
        c_detail = false,
        reach_limit = false;
    body.on("click", "a.add_to_compare", function() {
      
      // add loading 
      var $this = $(this), handle = $this.data('pid'),
          ls = Currency.cookie.rtread('rt-compare'),
          remove_added = false;

      reach_limit = false;
      $this.addClass("loading");
      if(ls != null && ls != ''){ 
        ls = ls.split(',');
      }else{
        ls = new Array();
      }
      if($this.hasClass('reach-limit')) {
        reach_limit = true;
        if($(this).hasClass('added') === false) {
          remove_added = true;
          jQuery("#rtp-message").html(theme.strings.c_msg);
          jQuery("#rt-unero-popup-message")
          .css(
            "margin-left",
            "-" + (parseFloat(jQuery("#rt-unero-popup-message").width()) / 2)  + "px"
          )
          .fadeIn();
          window.setTimeout(function() {
            jQuery("#rt-unero-popup-message").fadeOut();
          }, 2e3);
        }
      }
      
      if(ls.indexOf(handle)< 0 && $(this).hasClass('added') === false && reach_limit === false){
        ls.push(handle);
        var ls_ = ls.join(',');
        if (ls_.substring(0, 1) == ',') { 
          ls_ = ls_.substring(1);
        }
        Currency.cookie.rtwrite('rt-compare',ls_);
      }
      
      // moi load zo page hoac la add new 
      if( $(this).hasClass('added') === false || holder === '' ) {
       
        holder = '';
        $.ajax({
          url: '/search?view=compare&q='+ls,
          dataType: 'html',
          type: 'GET',
          success: function(responsive) {
            holder = responsive;
          },
          error: function(data) {
            console.log('ajax error');
            $this.removeClass("loading");
            
          },
          complete: function() {
            // check reach limit
            if(ls.length >= parseInt(theme.compare_limit)){
              $("a.add_to_compare").length > 0 && $("a.add_to_compare").each(function(){
                $(this).addClass('reach-limit')
              });
            }
            //open popup
            $.magnificPopup.open({
              items: { src: holder, type: "inline" },
              preloader: !0,
              tLoading: "",
              mainClass: "compare-preview",
              removalDelay: 200,
              gallery: { enabled: !0 },
              callbacks: {
                open: function() {
                  if(remove_added === false) {
                    $('[data-pid="'+handle + '"]' ).addClass('added').attr("data-original-title", $('[data-pid="'+handle + '"]' ).attr("data-added"));
                    $('[data-pid="'+handle+'"]' ).find('span').html($('[data-pid="'+handle + '"]' ).attr("data-added"));
                  }
                  $this.removeClass("loading");
                  //currency
                  theme.show_multiple_currencies && theme.CurrencyPicker.convert(".compare-content .money");
                  initReviews();
                  handleCompareScroll();
                }
              }
            });
          }
        });
      }
      else {
        $.ajax({
          url: '/search?view=compare&q='+ls,
          dataType: 'html',
          type: 'GET',
          success: function(responsive) {
            holder = responsive;
          },
          error: function(data) {
            console.log('ajax error');
            $this.removeClass("loading");
          },
          complete: function() {
            $.magnificPopup.open({
              items: { src: holder, type: "inline" },
              preloader: !0,
              tLoading: "",
              mainClass: "compare-preview",
              removalDelay: 200,
              gallery: { enabled: !0 },
              callbacks: {
                open: function() {
                  $this.removeClass("loading");
                  //currency
                  theme.show_multiple_currencies && theme.CurrencyPicker.convert(".compare-content .money");
                  initReviews();
                  handleCompareScroll();
                }
              }
            });
          }
        });
      }
    });
    //handle remove
    body.on('click', '.remove_from_compare', function(ev) {
      ev.preventDefault();
      var $this = $(this),handle = $this.attr('data-rev'),holder = $(".compare-content");
      $('[data-pid="'+handle + '"]' ).removeClass('added').attr("data-original-title",  $('[data-pid="'+handle + '"]' ).attr("data-title"));               
      $('[data-pid="'+handle+'"]' ).find('span').html($('[data-pid="'+handle + '"]' ).attr("data-title"));
      var ls = decodeURI(Currency.cookie.rtread('rt-compare'));
      
      if(ls != null){ 
        ls = ls.split(',');
        // check reach limit
        if(ls.length <= theme.compare_limit){
          $("a.add_to_compare").length > 0 && $("a.add_to_compare").each(function(){
            $(this).removeClass('reach-limit')
          });
        }
      }
      ls = jQuery.grep(ls, function(value) {
        return value != handle;
      });
      //ls.splice($.inArray(handle ,ls),1);
      ls  = $.trim(ls);
      Currency.cookie.rtwrite('rt-compare',ls);
      
      handleCompareScroll();
      $('.unero_'+handle).remove();
      if(ls.length <= 0 ){ 
        $('.mfp-close').trigger('click');
      }
      
    });
  }
  function autoloadCompare() {
    if( parseInt(theme.compare) == 0 ) return;
    var ls = Currency.cookie.rtread('rt-compare');
    if(ls != null){ 
      ls = ls.split(',');
      if(ls.length >= parseInt(theme.compare_limit)){
        $('.add_to_compare').addClass('reach-limit');
      }
      ls.map(function(elem, index) {
        $('[data-pid="'+elem+'"]' ).addClass('added').attr("data-original-title",  $('[data-pid="'+elem + '"]' ).attr("data-added"));               
        $('[data-pid="'+elem+'"]' ).find('span').html($('[data-pid="'+elem + '"]' ).attr("data-added"));
      });
    }else{
      ls = new Array();
    }
  }
  function initCompare (){
  	theme.compare == '1' && (handleCompareEvent(), autoloadCompare(), handleCompareScroll())
  }
  function lazyLoad() {
    $(document.body).find("img.lazy").lazyload({ threshold: 1000 });
  }
  function toolTipIcon() {
    $(".add_to_wishlist")
      .attr("data-original-title", $(".add_to_wishlist").html())
      .attr("rel", "tooltip");
    $("[rel=tooltip]").tooltip({ offsetTop: -15 });
  }
  function openCanvasPanel($panel) {
    $(document.body).addClass("open-canvas-panel");
    $panel.addClass("open");
  }
  function closeCanvasPanel() {
    $(document.body).removeClass("open-canvas-panel");
    $(".unero-off-canvas-panel, #primary-mobile-nav, #primary-offcanvas-wrapper").removeClass("open");
  }
  function canvasPanel() {
    $(document.body).on("click", ".cart-contents", function(e) {
      e.preventDefault();
      openCanvasPanel($("#cart-panel"));
    });

    $(document.body).on("click", "#icon-menu-sidebar", function(e) {
      e.preventDefault();
      openCanvasPanel($("#menu-sidebar-menu-sidebar"));
    });

    $(
      document.body
    ).on("click", "#off-canvas-layer, .close-canvas-panel", function(e) {
      e.preventDefault();
      closeCanvasPanel();
    });
  }
  function toggleModal() {
    $(document.body).on("click", "#menu-extra-search", function(e) {
      e.preventDefault();
      openModal($("#search-modal"));
      $(this).addClass("show");
    });

    $(document.body).on("click", ".close-modal", function(e) {
      e.preventDefault();
      closeModal();
    });
  }
  function initSwatchColor() {
    $(".un-attr-swatches").length > 0 && $(".un-attr-swatches").each(function() { $(this).find('.swatch').length == 1 && $(this).addClass("hide") }),    
    $(".un-swatch-variation-image").click(function() {
      !$(this).hasClass("selected") &&
        ($(this).attr("data-src") != "" &&
          $(this)
            .closest(".product-inner")
            .find(".product-item-image")
            .attr("src", $(this).attr("data-src"))
            .attr("srcset", $(this).attr("data-srcset")), $(this)
          .closest(".un-attr-swatches")
          .find(".un-swatch-variation-image")
          .removeClass("selected"), $(this).addClass("selected"));
    });
  }
  function toggleShopView() {
    $(document.body).on("click", ".un-shop-view", function(e) {
      e.preventDefault();
      var $el = $(this), view = $el.data("view");
      if ($el.hasClass("current")) {
        return;
      }
      $(document.body).find(".un-shop-view").removeClass("current");
      $el.addClass("current");
      $(document.body)
        .removeClass("shop-view-grid shop-view-list")
        .addClass("shop-view-" + view);
      $(document.body).trigger("unero_shop_view_after_change");
    });
    $(document.body).on("unero_shop_view_after_change", function() {
      lazyLoad();
    });
  }
  function showFilterContent() {
    var $shopToolbar = $("#un-shop-toolbar"),
      $shopTopbar = $("#un-shop-topbar"),
      $catsFilter = $("#un-categories-filter"),
      $ordering = $shopToolbar.find(".rt-unero-ordering"),
      $catalogSideBar = $(".catalog-sidebar"),
      $catalogOffCanvas = $(".catalog-offcanvas");

    $(window)
      .on("resize", function() {
        if ($(window).width() < 991) {
          $shopToolbar.addClass("on-mobile");
          $shopTopbar.addClass("on-mobile");
          $catalogSideBar.addClass("on-mobile");
          $catalogOffCanvas.addClass("on-mobile");
        } else {
          $catsFilter.removeAttr("style");
          $("#un-toggle-cats-filter").removeClass("active");
          $shopToolbar.removeClass("on-mobile");
          $shopTopbar.removeClass("on-mobile");
          $catalogSideBar.removeClass("on-mobile");
          $catalogOffCanvas.removeClass("on-mobile");
          $shopTopbar.find(".widget-title").next().removeAttr("style");
          $catalogSideBar.find(".widget-title").next().removeAttr("style");
        }
      })
      .trigger("resize");
    
    $(document.body)
    .find(".shop-toolbar, .shop-bottombar")
    .on("click", ".un-filter.filter-canvas", function(e) {
      e.preventDefault();
      $('#primary-offcanvas-wrapper').toggleClass("open");
      $(document.body).toggleClass("open-canvas-panel");
      if ($(this).closest(".shop-toolbar").hasClass("on-mobile")) {
        $catsFilter.slideUp(200);
        $ordering.slideUp(200);
        $("#un-toggle-cats-filter").removeClass("active");
        $("#un-ordering").removeClass("active");
        setTimeout(function() {
          $shopTopbar.slideToggle(200);
        }, 200);
      }
      $(document.body).toggleClass("show-filters-content");
    });
    
    $('#primary-offcanvas-wrapper').length > 0 && $('#primary-offcanvas-wrapper').on("click", ".close-canvas-shop-panel", function(e) {
      e.preventDefault();
      closeCanvasPanel();
    });
    
    $(document.body)
      .find(".shop-toolbar, .shop-bottombar")
    .on("click", ".un-filter:not(.filter-canvas)", function(e) {
        e.preventDefault();

        if ($(this).closest(".shop-toolbar").hasClass("on-mobile")) {
          $catsFilter.slideUp(200);
          $ordering.slideUp(200);
          $("#un-toggle-cats-filter").removeClass("active");
          $("#un-ordering").removeClass("active");
          setTimeout(function() {
            $shopTopbar.slideToggle(200);
          }, 200);
        } else {
          $shopTopbar.slideToggle();
        }

        $shopTopbar.toggleClass("active");
        $(this).toggleClass("active");
        $shopTopbar.closest(".shop-bottombar").toggleClass("show");
        $("#un-filter-overlay").toggleClass("show");

        $(document.body).toggleClass("show-filters-content");
      });

    $(document.body).on("click", "#un-filter-overlay", function(e) {
      e.preventDefault();
      $shopTopbar.slideToggle();
      $(".un-filter").removeClass("active");
      $shopTopbar.closest(".shop-bottombar").toggleClass("show");
      $("#un-filter-overlay").toggleClass("show");
      $shopTopbar.removeClass("active");

      $(document.body).removeClass("show-filters-content");
    });

    $(document.body).on("click", "#un-toggle-cats-filter", function(e) {
      e.preventDefault();
      if ($(this).closest(".shop-toolbar").hasClass("on-mobile")) {
        $shopTopbar.slideUp(200);
        setTimeout(function() {
          $catsFilter.slideToggle(200);
        }, 200);

        $(this).toggleClass("active");
        $(".un-filter").removeClass("active");
        $shopTopbar.removeClass("active");
      }
    });

    $(document.body).on("click", "#un-ordering", function(e) {
      e.preventDefault();
      if ($(this).closest(".shop-toolbar").hasClass("on-mobile")) {
        $shopTopbar.slideUp(200);
        setTimeout(function() {
          $ordering.slideToggle(200);
        }, 200);

        $(this).toggleClass("active");
        $(".un-filter").removeClass("active");
        $shopTopbar.removeClass("active");
      }
    });

    $shopTopbar.on("click", ".widget-title", function(e) {
      if ($(this).closest(".shop-topbar").hasClass("on-mobile")) {
        e.preventDefault();

        $(this)
          .closest(".widget")
          .siblings()
          .find(".widget-title")
          .next()
          .slideUp(200);
        $(this).closest(".widget").siblings().removeClass("active");

        $(this).next().slideToggle(200);
        $(this).closest(".widget").toggleClass("active");
      }
    });

    $catalogSideBar.on("click", ".widget-title", function(e) {
      
        e.preventDefault();

        $(this)
          .closest(".widget")
          .siblings()
          .find(".widget-title")
          .next()
          .slideUp(200);
        $(this).closest(".widget").siblings().removeClass("active");

        $(this).next().slideToggle(200);
        $(this).closest(".widget").toggleClass("active");
      
    });
    $catalogOffCanvas.on("click", ".widget-title", function(e) {
      if ($(this).closest(".catalog-offcanvas").hasClass("on-mobile")) {
        e.preventDefault();

        $(this)
          .closest(".widget")
          .siblings()
          .find(".widget-title")
          .next()
          .slideUp(200);
        $(this).closest(".widget").siblings().removeClass("active");

        $(this).next().slideToggle(200);
        $(this).closest(".widget").toggleClass("active");
      }
    });
  }
  function shopLayout() {
    if (!$(document.body).hasClass("catalog-board-content")) {
      return;
    }
    $(document.body).imagesLoaded(function() {
      $("#un-shop-content").find("ul.products").isotope({
        itemSelector: "li.product",
        layoutMode: "masonry"
      });
    });
  }
  function metroLayout() {
    if (!$(document.body).hasClass("collection-metro-content")) {
      return;
    }
    $(document.body).imagesLoaded(function() {
      $("#un-shop-content").find("ul.products").isotope({
        itemSelector: "li.product",
        layoutMode: "masonry"
      });
    });
  }
  function blogLayout() {
    if (!$("#unero-site-content").hasClass("blog-layout-masonry")) {
      return;
    }
    $(document.body).imagesLoaded(function() {
      $("#unero-site-content").find(".unero-post-list").isotope({
        itemSelector: ".un-post-item",
        layoutMode: "masonry"
      });
    });
  }
  function portfolioCarousel() {
    if (!$(document.body).hasClass("portfolio-layout-carousel")) {
      return;
    }

    var $wrap = $("#unero-site-content"),
      $frame = $wrap.find(".unero-post-frame"),
      start = 2,
      autoplay = 0,
      speed = 5000;

    if (start > 0) {
      start = start - 1;
    }

    if (autoplay > 0) {
      speed = autoplay;
      autoplay = 1;
    } else {
      autoplay = 0;
    }

    var options = {
      horizontal: 1,
      smart: 1,
      itemNav: "forceCentered",
      activateOn: "click",
      touchDragging: 1,
      mouseDragging: 1,
      releaseSwing: 1,
      startAt: start,
      scrollBar: $wrap.find(".scrollbar"),
      speed: 1000,
      elasticBounds: 1,
      dragHandle: 1,
      dynamicHandle: 1,
      clickBar: 1,

      // Cycling
      cycleBy: "items",
      cycleInterval: speed,
      pauseOnHover: autoplay
    };

    var $sliders = new Sly($frame, options);

    $sliders.on("load move", function() {
      $wrap.addClass("loaded");
    });

    $sliders.init();

    $(window)
      .resize(function() {
        var wWidth = $(window).width(), sWidth = wWidth - 60;

        if ($(document.body).hasClass("boxed")) {
          wWidth = $(".site").width();
        }

        if (wWidth < 1024) {
          sWidth = wWidth - 30;
        }

        if (wWidth < 1200) {
          $(".portfolio-layout-carousel")
            .find(".portfolio-wapper")
            .width(sWidth);
        } else {
          $(".portfolio-layout-carousel")
            .find(".portfolio-wapper")
            .removeAttr("style");
        }

        $sliders.reload();
      })
      .trigger("resize");
  }
  function animationProduct() {
    if (!$("#content").hasClass("animation-product")) {
      return;
    }

    var $elements = $(document.body).find("#un-shop-content .product-inner");

    $elements.removeAttr("data-sr-id").removeAttr("style");

    var config = {
      viewFactor: 0.15,
      duration: 1000,
      scale: 0.9,
      opacity: 1,
      easing: "ease"
    };
    window.sr = new ScrollReveal(config);

    var block = {
      reset: true,
      viewOffset: { top: 64 }
    };

    sr.reveal($elements, block);
  };
  function pageHeader() {

    if (!$('.page-header').hasClass('page-header-sliders')) {
      $('.page-header.parallax').parallax('50%', 0.6);
      return;
    }

    var $pageHeader = $('.page-header-sliders'),
        speed = $pageHeader.data('speed'),
        fade = false,
        autoplay = $pageHeader.data('auto'),
        parallax = $pageHeader.data('parallax');
    if (parallax== "1") {
      fade = true;
    }
    $pageHeader.find('ul').not('.slick-initialized').slick({
      slidesToShow  : 1,
      slidesToScroll: 1,
      infinite      : true,
      autoplaySpeed : speed,
      autoplay      : autoplay,
      fade          : fade,
      cssEase       : 'linear',
      prevArrow     : '<span class="icon-chevron-left slick-prev-arrow"></span>',
      nextArrow     : '<span class="icon-chevron-right slick-next-arrow"></span>'
    });

    if (parallax == '0') {
      $('.page-header-sliders.parallax').find('li').parallax('50%', 0.6);

    } else {
      var hPageHeader = $pageHeader.height();
      if ($(document.body).hasClass('admin-bar')) {
        hPageHeader = hPageHeader - 32;
      }
	  
      $('#content').css('margin-top', hPageHeader);

      $pageHeader.addClass('parallax-2');

      $(window).on('scroll', function () {
        var wScrollTop = $(window).scrollTop();
        if (wScrollTop > 0) {
          $('.page-header-sliders.parallax-2').css({opacity: (hPageHeader - wScrollTop) / hPageHeader});
        } else {
          $('.page-header-sliders.parallax-2').css({opacity: 1});
        }
      });
    }

  };
  function newsletterPopup() {
    function newsletterMailChimp(){
      var n = $("#mc-form.newsletter"),
          r = n.attr("action");
      n.ajaxChimp({
        url: r,
        callback: function(e) {
          e.result === "success" && closeModal();
        }
      });
    }
    function newsletterKlaviyo(){
      KlaviyoSubscribe.attachToForms('#email_signup', {
        hide_form_on_success: true,
        success: function () {
          closeModal();
        }
      });
    }
    if ($('#popup-mailchimp').length) {
      var days = parseInt(theme.popup_mailchimp_period),
          delay = parseInt(theme.popup_mailchimp_delay);
      if (days > 0 && document.cookie.match(/^(.*;)?\s*unero_popup\s*=\s*[^;]+(.*)?$/)) {
        return;
      }
      delay = Math.max(delay, 0);
      $(window).on('load', function() {
        setTimeout(function() {
          $(document.body).addClass('modal-open');
          $('.popup-modal').fadeIn();
          $('.popup-modal').addClass('open');
        }, delay * 1000);
      });
      $(document.body).on('roar_modal_closed', function(event, modal) {
        if (!modal.hasClass('roar-popup')) {
          return;
        }
        var date = new Date(),
            value = date.getTime();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = 'unero_popup=' + value + ';expires=' + date.toGMTString() + ';path=/';
      });
      if($("#popup-mailchimp").hasClass("popup-klaviyo")){
        newsletterKlaviyo();
      }else{
        newsletterMailChimp();
      }
      function closeModal() {
        $(document.body).removeClass('modal-open');
        var $opened = $('.popup-modal.open');
        $opened.fadeOut(function() {
          $(this).removeClass('open');
        });
        $(document.body).trigger('roar_modal_closed', [$opened]);
      }
      $(document.body).on('click', '.close-modal, .popup-backdrop', function(e) {
        e.preventDefault();
        closeModal();
      });
      $(document).on('keyup', function(e) {
        if (e.keyCode === 27) {
          closeModal();
        }
      });
    }
  }
  function notifyProducts() {
    $(window).on('load', function() {
      if (typeof window.notifySettings !== 'undefined') {
        notifyProIO.settings = {};
        notifyProIO.settings.message = window.notifySettings.message;
        notifyProIO.settings.hideMobile = true;
        notifyProIO.settings.initialDelay = 3000;
        notifyProIO.settings.displayInterval = window.notifySettings.displayInterval;
        notifyProIO.settings.displayHold = window.notifySettings.displayHold;
        notifyProIO.settings.totalPerPage = window.notifySettings.totalPerPage;
        notifyProIO.settings.totalDisplayed = 0;
        notifyProIO.settings.loop = true;
        notifyProIO.setup(window.notifyProducts);
      }
    });
  }
  function cookiePopup() {
    if (document.cookie.match(/^(.*;)?\s*unero_cookie\s*=\s*[^;]+(.*)?$/)) {
      $('.cc_container').remove();
      return;
    }
    $(window).on('load', function() {
      setTimeout(function() {
        $('.cc_container').addClass('open');
      }, 5000);
    });
    $(".cc_btn").click(function(e) {
      e.preventDefault();
      
      var date = new Date(),
          value = date.getTime();
      date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
      document.cookie = 'unero_cookie=' + value + ';expires=' + date.toGMTString() + ';path=/';
      
      $('.cc_container').removeClass('open');
    });
  }
  function initCountDown() {
    $().countdown && $('.countdown-item:not(.is-countdown)').length > 0 && $('.countdown-item:not(.is-countdown)').each(function(){
      if($(this).data('countdown') != "" ){
        var currentDay = new Date();
        var offerDay = $(this).data('countdown').split('-');
        var offerDay = new Date( offerDay[2], (parseInt(offerDay[0]) - 1), offerDay[1] );
        if(currentDay < offerDay){
          $(this).countdown({
            until: offerDay,
            layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'

          });
        }
      }
    });
  }
  function initHeaderMixedContent() {
    if($(document.body).hasClass('header-mixed-content')){
      $(".site-content .shopify-section").first().css('margin-top', -$(".site-header").height())
    }
  }
  
  function initMoreDetail(){
    $(".more-details-btn").on("click", function( event ) {
      event.preventDefault();
      $(this).closest(".hover-content").addClass("show-full-description");
      var _mBottom =  $(this).closest(".unero-fade-in-block").height() + 15;
      //console.log(_mBottom);
      $(this).closest(".product-item-details").find(".unero-product-item-imagin").css("margin-bottom","-" + _mBottom + "px" );
    });
  }
  function changeInputNameCartPage() {
    var name= "updates[]";
    if ($(window).width() > 767) {
      $(".input-mobile").attr("name", "");
      $(".input-desktop").attr("name", name);
    }
    else {
      $(".input-mobile").attr("name", name);
      $(".input-desktop").attr("name", "");
    }
  }
  function initChangeInputNameCartPage(){
    if ($("template-cart .input-mobile").length && $("template-cart .input-desktop").length ) {
      changeInputNameCartPage();
      $(window).resize(function(){
        changeInputNameCartPage();
      });
    }
  }
  return {
    init: function() {
      initChangeInputNameCartPage();
      showFilterContent();
      toggleShopView();
      lazyLoad();
      toolTipIcon();
      addToWishlist();
      removeFromWishlist();
      initReviews();
      initCountDown();
      initSwatchColor();
      mapProduct();
      toggleModal();
      canvasPanel();
      animationProduct();
      shopLayout();
      metroLayout();
      blogLayout();
      portfolioCarousel();
      pageHeader();
      toTop();
      newsletterPopup();
      notifyProducts();
      cookiePopup();
      initCompare();
      initHeaderMixedContent();
      initMoreDetail();
    },
    pageHeader: function() {
      pageHeader();
    },
    initLoadMore: function() {
      lazyLoad();
      toolTipIcon();
      initReviews();
      initCountDown();
      animationProduct();
      initSwatchColor();
      shopLayout();
      metroLayout();
      blogLayout();
      initMoreDetail();
    }
  };
})();

theme.init = function() {
  theme.roarApplication.init();
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function(evt) {
    evt.preventDefault();
  });
};

try {
  $(theme.init);
} finally {
  var $unloader = $("#un-before-unloader");
  $(window).on("beforeunload", function() {
    $unloader.removeClass("out").fadeIn(500, function() {
      $unloader.addClass("loading");
    });
  });
  $unloader.fadeOut(200, function() {
    $unloader.addClass("out");
  });
}